'use strict';

import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { debounceTime, Subscription } from 'rxjs';
import { AppStateService } from '../app-state.service';
import { TypZaznamuTextu } from '../model/typ-zaznamu-textu';
import { UntypedFormBuilder } from '@angular/forms';
import { ZaznamTextu } from '../model/zaznam-textu';
import { OkDialogComponent } from 'projects/ais-common/src/public-api';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DatePipe, ViewportScroller } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { VSKDokument } from '../model/vsk-dokument';
import { ErrorDialogComponent } from 'projects/ais-common/src/public-api';
import { StudijnyProgram } from '../model/studijny-program';
import { RequestZKlienta } from '../model/request-z-klienta';
import { StudijneProgramyStavPreJazyk } from '../model/studijne-programy-stav-pre-jazyk';
import { StudijneProgramyCopyingDialogComponent } from '../studijne-programy-copying-dialog/studijne-programy-copying-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { PodprogramyCopyingDialogComponent } from '../podprogramy-copying-dialog/podprogramy-copying-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-formular',
    templateUrl: './formular.component.html',
    styleUrls: ['./formular.component.css'],
    standalone: false
})
export class FormularComponent implements OnInit, OnDestroy {

  pocetSkupinovychOpakovaniTEST = 0;

  idDruhDokumentu: number;
  idTypDokumentuTextu: number;
  idStudProgram: number = -1;
  // habilitacne a inauguracne konanie
  // haik = false;
  idOsoby: number = -1;
  fakulta: string = null;
  idPodprogram: number = -1;
  akRok: string = null;

  data: VSKDokument;

  readonly TYP_DOKUMENTU_OPIS_STUDIJNEHO_PROGRAMU = 1;

  readonly NADPIS: number = 1;
  readonly BLOK: number = 2;
  readonly SEKCIA: number = 3;
  readonly POLOZKA: number = 4;

  readonly INPUT: number = 1;
  readonly TEXTAREA: number = 2;
  readonly SELECT: number = 3;
  readonly AUTOCOMPLETE: number = 4;
  readonly DATE: number = 5;
  readonly NON_NEGATIVE_INTEGER: number = 6;

  readonly DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK = 1;
  readonly DOKUMENT_TEXT_OSOBY = 2;
  readonly DOKUMENT_TEXT_PODPROGRAMU = 3;
  readonly HABILITACNE_A_INAUGURACNE_KONANIE = 4;

  readonly OPAKOVANA_POLOZKA_PODPROGRAMU = 1;

  readonly INSERT = 'I';
  readonly UPDATE = 'U';
  readonly DELETE = 'D';

  readonly VAZBA_STUPEN_TYP_STUDIA: number = 1;

  readonly PRIEZVISKO_VUPCH = -2;
  readonly MENO_VUPCH = -3;
  readonly TITULY_VUPCH = -4;
  readonly ROK_NARODENIA_VUPCH = -5;

  readonly TYPY_POLOZIEK_OSOBNE_UDAJE_VUPCH
    = [this.PRIEZVISKO_VUPCH,
      this.MENO_VUPCH,
      this.TITULY_VUPCH,
      this.ROK_NARODENIA_VUPCH];


  readonly PRIEZVISKO_VTC = -152;
  readonly MENO_VTC = -153;
  readonly TITULY_VTC = -154;

  readonly TYPY_POLOZIEK_OSOBNE_UDAJE_VTC
    = [this.PRIEZVISKO_VTC,
      this.MENO_VTC,
      this.TITULY_VTC];

  // mapa zmenenych osobnych udajov formulara udajmi z LZOsoba
  zmeneneOsobneUdajePreJazykMapa: Map<string, string[]> = new Map();
  zobrazenaInformaciaOZmeneOsobnychUdajovPreJazykMapa: Map<string, boolean> = new Map();

  readonly TYP_DOKUMENTU_VUPCH = -1;
  readonly TYP_DOKUMENTU_VTC = -15;

  spinner = false;

  formularJePredvyplneny = false;

  kodJazykRadioBox: string = null;

  jazyk1: string = null;
  jazyk2: string = null;
  jazyk3: string = null;
  existujeJazyk2 = false;
  existujeJazyk3 = false;

  dataSubscription: Subscription;
  zaznamyTextovDataSavedSubscription: Subscription;
  zaznamyTextovDataSubscription: Subscription;
  aktualnaStranaSubscription: Subscription;
  pocetPripustnychSPPodprogramuSubscription: Subscription;
  infoOExistenciiDokumentovSubscription: Subscription;

  typyZaznamuTextu: TypZaznamuTextu[];
  // visibleDataByPage: TypZaznamuTextu[];

  zaznamyTextovZDB: ZaznamTextu[];
  zaznamyTextuZDBIdTypAText = {};

  pocetStran: number = 1;
  // poleStran: number[] = [1,2,3,4,5,6];
  poleStran: number[] = [];

  zobrazitHelpText = false;
  value = 'Clear me';
  valueTextArea = 'Clear me - textarea';
  // disableSelect = new FormControl(false);

  formularFormGroup = this.formBuilder.group({});
  // formArray = this.formBuilder.array([]);

  typyZaznamovNaStranu: TypZaznamuTextu[] = [];
  aktualnaStrana: number = 1;

  formArrayJazyk1: UntypedFormArray = new UntypedFormArray([]);
  formArrayJazyk2: UntypedFormArray = new UntypedFormArray([]);
  formArrayJazyk3: UntypedFormArray = new UntypedFormArray([]);

  // formArrayAutocomplete: FormArray = new FormArray([]);
  poleFormArraysOfAutocomplete: UntypedFormArray[] = [];
  mapaIdTypovAPoliAutocompletov: Map<number, UntypedFormArray> = new Map();
  mapaIdTypovAPoliAutocompletovJazyk2: Map<number, UntypedFormArray> = new Map();
  mapaIdTypovAPoliAutocompletovJazyk3: Map<number, UntypedFormArray> = new Map();

  mapaIdSkupinAMapCastiATypovZaznamov: Map<number, Map<number, TypZaznamuTextu[]>> = new Map();
  mapaIdSkupinAMapCastiATypovZaznamovJazyk2: Map<number, Map<number, TypZaznamuTextu[]>> = new Map();
  mapaIdSkupinAMapCastiATypovZaznamovJazyk3: Map<number, Map<number, TypZaznamuTextu[]>> = new Map();

  mapaIdSkupinAMaxPoctovOpakovani: Map<number, number> = new Map();
  // mapaCastiSkupinAJejTypov: Map<number, TypZaznamuTextu[]> = new Map();
  // mapaIdSkupinATypovZaznamovEN: Map<number, TypZaznamuTextu[]> = new Map();
  mapaPoctovZaznamovPreSkupinu: Map<number, number> = new Map();
  // <idSkupina, pocet typov (distinct), ktore do skupiny patria>
  mapaIdJednoznacnychTypovVSkupine: Map<number, number[]> = new Map();

  mapaIdTypovAPoziciiVCastiSkupiny: Map<number, number[]> = new Map();
  mapaIdTypovAPoziciiVCastiSkupinyJazyk2: Map<number, number[]> = new Map();
  mapaIdTypovAPoziciiVCastiSkupinyJazyk3: Map<number, number[]> = new Map();

  mapaIdSkupinAPoctovOpakovani: Map<number, number> = new Map();
  mapaIdSkupinAPoctovOpakovaniJazyk2: Map<number, number> = new Map();
  mapaIdSkupinAPoctovOpakovaniJazyk3: Map<number, number> = new Map();

  mapaIdSkupinACastiSkupin: Map<number, number[]> = new Map();
  mapaIdSkupinACastiSkupinJazyk2: Map<number, number[]> = new Map();
  mapaIdSkupinACastiSkupinJazyk3: Map<number, number[]> = new Map();

  // mapu pouzivame v nadpis-blok-sekcia-druh.component.ts, kde emitujeme event pridatSkupinoveOpakovanie
  mapaJazykovAMapIdSkupinACastiSkupin: Map<string, Map<number, number[]>> = new Map();

  mapaIdTypovAHodnotAtributuPodprogram: Map<number, number> = new Map();


  poleIdciekZaznamov: number[] = [];

  disablovatNavigacneButtonyKvoliZadaniuStrany = false;
  disablujPotvrdzovaciButton = false;
  zvolenaStrana = -1;

  pocetSkopirovanychPoloziek = 0;

  mapaIdTypovAIchIdSkupin: Map<number, number> = new Map();

  zmenaVSledovanychPolozkachVJazykochMapa: Map<string, boolean> = new Map();
  datumPoslednejAktualizacieBolManualneZmeneny = false;

  private subscriptions: Subscription[] = [];

  dialog = inject(MatDialog);

  private destroyRef = inject(DestroyRef);
  private typDatumPoslednejAktualizacie: TypZaznamuTextu;

  constructor(public appStateService: AppStateService,
    private formBuilder: UntypedFormBuilder,
    private scroller: ViewportScroller,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {

    // this.router.navigate(['/']);

    this.route.queryParamMap
      .subscribe(params => {

        // console.log('queryParamMap: ' + JSON.stringify(params));

        if (params.get('idTypDokumentu')) {
          this.idTypDokumentuTextu = +params.get('idTypDokumentu');
          if (this.idTypDokumentuTextu === null) {
            this.idTypDokumentuTextu = 1;
          }
          this.appStateService.idTypDokumentu = this.idTypDokumentuTextu;

          // console.log('queryParams idTypDokumentu: ' + this.idTypDokumentuTextu);
        }

        // if (params.get('idDruhDokumentu')) {
        //   this.idDruhDokumentuTextu = +params.get('idDruhDokumentu');
        //   if (this.idDruhDokumentuTextu === null) {
        //     this.idDruhDokumentuTextu = 1;
        //   }
        // }

        if (params.get('idStudProgram')) {
          this.idStudProgram = +params.get('idStudProgram');
          if (this.idStudProgram === null) {
            this.idStudProgram = 0;
          } else {
            this.idDruhDokumentu = this.DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK;
            this.appStateService.idDruhDokumentu = this.DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK;
            this.appStateService.idDruhDokumentuDB = this.DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK;
          }
          this.appStateService.idStudProgram = this.idStudProgram;
          // console.log('queryParams idStudProgram: ' + this.idStudProgram);
        }

        if (params.get('haik')) {
          const haik = params.get('haik');
          if (haik === 'true' ) {
            this.appStateService.idDruhDokumentu = this.HABILITACNE_A_INAUGURACNE_KONANIE;
            this.appStateService.idDruhDokumentuDB = this.DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK;
            this.appStateService.haikOdbor = true;
          }
          // console.log('queryParams idStudProgram: ' + this.idStudProgram);
        }

        if (params.get('idOsoba')) {
          this.idOsoby = +params.get('idOsoba');
          if (this.idOsoby === null) {
            this.idOsoby = 0;
          } else {
            this.appStateService.idDruhDokumentu = this.DOKUMENT_TEXT_OSOBY;
            this.appStateService.idDruhDokumentuDB = this.DOKUMENT_TEXT_OSOBY;
            this.idDruhDokumentu = this.DOKUMENT_TEXT_OSOBY;
            this.appStateService.idOsoba = this.idOsoby;
          }
          // console.log('queryParams idStudProgram: ' + this.idStudProgram);
        }

        if (params.get('idPodprogram')) {
          this.idPodprogram = +params.get('idPodprogram');
          if (this.idPodprogram === null) {
            this.idPodprogram = 0;
          } else {
            this.idDruhDokumentu = this.DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK;
            this.appStateService.idDruhDokumentu = this.DOKUMENT_TEXT_PODPROGRAMU;
            this.appStateService.idDruhDokumentuDB = this.DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK;
          }
          this.appStateService.idPodprogram = this.idPodprogram;
          // console.log('queryParams idStudProgram: ' + this.idStudProgram);
        }

        // TODO: konverzia YYYY/YYYY na YYYY_YYYY, prip. naopak
        if (params.get('akRok') && params.get('akRok') !== 'null') {
          const akRok = params.get('akRok').replace('-', '/').replace('_', '/');
          this.akRok = akRok;
          this.appStateService.akRok = this.akRok;
          // console.log('queryParams fakulta: ' + this.fakulta);
        }

        if (params.get('fakulta')) {
          this.fakulta = params.get('fakulta');
          this.appStateService.fakulta = params.get('fakulta');
          // console.log('queryParams fakulta: ' + this.fakulta);
        }

        if (params.get('jazyk')) {
          this.kodJazykRadioBox = params.get('jazyk');
          // console.log('queryParams jazyk: ' + params.get('jazyk'));
        }

        if (this.idTypDokumentuTextu) {
          // console.log('spinner zapnut!');
          this.spinner = true;
          this.appStateService.fetchData(this.idTypDokumentuTextu, this.idStudProgram,
            this.idOsoby, this.idPodprogram, this.fakulta);
        }

      });

    // this.router.navigateByUrl('vsk');



    this.dataSubscription = this.appStateService.dataFetched
    .subscribe((data: VSKDokument) => {

      // TODO:
      // potrebujeme overit stavy dokumentov
      this.appStateService.ziskajStavyDokumentov();

      this.data = data;

      this.appStateService.jazykyFormulara = this.data.jazykyFormulara;
      const jazykyFormularaPole = this.data.jazykyFormulara;
      this.jazyk1 = jazykyFormularaPole[0];
      this.jazyk2 = jazykyFormularaPole.length >= 2 ? jazykyFormularaPole[1] : null;
      this.jazyk3 = jazykyFormularaPole.length >= 3 ? jazykyFormularaPole[2] : null;
      if (!this.kodJazykRadioBox) {
        this.kodJazykRadioBox = this.jazyk1;
      }

      this.appStateService.vybranyJazykFormulara = this.kodJazykRadioBox;
      this.appStateService.jazykFormulara1 = this.jazyk1;
      this.appStateService.jazykFormulara2 = this.jazyk2;
      this.appStateService.jazykFormulara3 = this.jazyk3;

      this.existujeJazyk2 = this.jazyk2 !== null;
      this.existujeJazyk3 = this.jazyk3 !== null;

      this.typyZaznamuTextu = data.typyZaznamovTextu;

      this.typyZaznamovNaStranu = this.getTypyZaznamovPodlaStrany(1);

      this.poleStran = this.getPoleStran();
      this.pocetStran = this.getPocetStran();

      this.appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty = data.pouzivatelMozeEditovatUroven2;

      // potrebujeme  doplnit polozky, ktore su v DB, ale vo formulari zatial nie
      const pouzivatelMozeEditovatPolozkyZUrovneFakulty
        = this.appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty;


      this.naplnPotrebneMapy();

      for (let i = 0; i < this.typyZaznamuTextu.length; i++) {

        const typ:TypZaznamuTextu = this.typyZaznamuTextu[i];

        // ak je SCSTTypZaznamuTextu.uroven == 2 (uroven fakulty),
        // treba sa pozriet na roly pouzivatela (robi sa to na servri)
        // spms 119997
        // TODO:
        let disablujPolozku = false;
        if (typ.uroven === 2 && !pouzivatelMozeEditovatPolozkyZUrovneFakulty) {
          disablujPolozku = true;
        }


        if (this.idPodprogram > 0 && typ.podprogram) {
          this.mapaIdTypovAHodnotAtributuPodprogram.set(typ.id, typ.podprogram);
        }

        // if (typ.opakovanie === 'A' || typ.idSkupina) {
        //   this.poleIdciekOpakovanychASkupinovychTypov.push(typ.id);
        // }

        // OPAKOVANIE
        if (typ.opakovanie === 'A' || (this.appStateService.jeOpakovaniePodprogramu(typ))) {

          // console.log('OPAKOVANIE');

          // jazyk 1
          const menoArrayControlsuJazyk1:string = 'name_' + typ.id + '_' + this.jazyk1;
          // const haha = new FormArray([]);
          // haha.disable();
          this.formularFormGroup.addControl(menoArrayControlsuJazyk1,
            new UntypedFormArray([]));

          // jazyk 2
          let menoArrayControlsuJazyk2: string = null;
          if (this.existujeJazyk2) {
            menoArrayControlsuJazyk2 = 'name_' + typ.id + '_' + this.jazyk2;
            this.formularFormGroup.addControl(menoArrayControlsuJazyk2,
              new UntypedFormArray([]));
          }

          // jazyk 3
          let menoArrayControlsuJazyk3: string = null;
          if (this.existujeJazyk3) {
            menoArrayControlsuJazyk3 = 'name_' + typ.id + '_' + this.jazyk3;
            this.formularFormGroup.addControl(menoArrayControlsuJazyk3,
              new UntypedFormArray([]));
          }

          // SKUPINOVE OPAKOVANIE
          if (typ.idSkupina && typ.idSkupina !== 0) {

            // typ.opakovanie === 'A' a sucasne typ.idSkupina mame len pri skupinovych typoch, ktore urcuju pocet opakovani
            this.mapaIdSkupinAMaxPoctovOpakovani.set(typ.id, typ.maxPocet);

            let posun = 0;
            let poradie = 0;
            // defaultne opakujeme polozky v idSkupine minPocet-krat
            for (let index = 0; index < typ.minPocet; index++) {

              //SK
              if (!this.mapaIdSkupinAPoctovOpakovani.has(typ.idSkupina)) {
                this.mapaIdSkupinAPoctovOpakovani.set(typ.idSkupina, 1);
              } else {
                this.mapaIdSkupinAPoctovOpakovani.set(typ.idSkupina,
                  this.mapaIdSkupinAPoctovOpakovani.get(typ.idSkupina) + 1);
              }

              // EN
              if (this.existujeJazyk2) {
                if (!this.mapaIdSkupinAPoctovOpakovaniJazyk2.has(typ.idSkupina)) {
                  this.mapaIdSkupinAPoctovOpakovaniJazyk2.set(typ.idSkupina, 1);
                } else {
                  this.mapaIdSkupinAPoctovOpakovaniJazyk2.set(typ.idSkupina,
                    this.mapaIdSkupinAPoctovOpakovaniJazyk2.get(typ.idSkupina) + 1);
                }
              }

              // 3. jazyk
              if (this.existujeJazyk3) {
                if (!this.mapaIdSkupinAPoctovOpakovaniJazyk3.has(typ.idSkupina)) {
                  this.mapaIdSkupinAPoctovOpakovaniJazyk3.set(typ.idSkupina, 1);
                } else {
                  this.mapaIdSkupinAPoctovOpakovaniJazyk3.set(typ.idSkupina,
                    this.mapaIdSkupinAPoctovOpakovaniJazyk3.get(typ.idSkupina) + 1);
                }
              }

              // prejdeme vsetky polozky v skupine (idSkupina)
              for (let ind = i + 1; ind < this.typyZaznamuTextu.length; ind++) {
                const t = this.typyZaznamuTextu[ind];
                if (t.idSkupina === typ.idSkupina) {

                  if (!this.mapaIdJednoznacnychTypovVSkupine.has(t.idSkupina)) {
                    this.mapaIdJednoznacnychTypovVSkupine.set(t.idSkupina, [t.id]);
                  } else {
                    let pole = this.mapaIdJednoznacnychTypovVSkupine.get(t.idSkupina);
                    if (!pole.find(tID => tID === t.id)) {
                      this.mapaIdJednoznacnychTypovVSkupine.get(t.idSkupina).push(t.id);
                    }
                  }

                  const disablujSkupinovuPolozku
                    = t.uroven === 2 && !this.appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty;

                  this.formArrayJazyk1 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk1);
                  this.formArrayJazyk1.push(new UntypedFormControl({value: t.textPredvoleny,
                    disabled: disablujSkupinovuPolozku}));

                  if (this.existujeJazyk2) {
                    this.formArrayJazyk2 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk2);
                    this.formArrayJazyk2.push(new UntypedFormControl({value: t.textPredvolenyJazyk2,
                      disabled: disablujSkupinovuPolozku}));
                  }

                  if (this.existujeJazyk3) {
                    this.formArrayJazyk3 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk3);
                    this.formArrayJazyk3.push(new UntypedFormControl({value: t.textPredvolenyJazyk3,
                      disabled: disablujSkupinovuPolozku}));
                  }
                  // potrebujeme vediet, o kolko sa mame posunut vo vonkajsom cykle typovZaznamuTextu
                  // posun staci vypocitat raz
                  if (index === 0) {
                    posun++;
                  }

                  poradie++;

                  // if (!this.mapaIdSkupinAIdTypovObjektov.has(typ.idSkupina)) {
                  //   this.mapaIdSkupinAIdTypovObjektov.set(typ.idSkupina, [t.idTypObjektu]);
                  // } else {
                  //   this.mapaIdSkupinAIdTypovObjektov.get(typ.idSkupina).push(t.idTypObjektu);
                  // }

                  // SK
                  // v mape mame pre kazdu skupinu vsetky jej typy zaznamov (minimalne (typ.minPocet * pocet typov v skupine)) rozdelene
                  // do jednotlivych casti (podla tychto casti sa budu zobrazovat vo formulari v samostatnom <mat-card>)
                  if (!this.mapaIdSkupinAMapCastiATypovZaznamov.has(typ.idSkupina)) {
                    let mapaCastiSkupinAJejTypov: Map<number, TypZaznamuTextu[]> = new Map();
                    mapaCastiSkupinAJejTypov.set(index + 1, [t]);
                    this.mapaIdSkupinAMapCastiATypovZaznamov.set(typ.idSkupina, mapaCastiSkupinAJejTypov);
                  } else {
                    const mapa = this.mapaIdSkupinAMapCastiATypovZaznamov.get(typ.idSkupina);
                    // mapa.set(index + 1, );
                    if (!mapa.has(index + 1)) {
                      mapa.set(index + 1, [t]);
                    } else {
                      mapa.get(index + 1).push(t);
                    }
                  }

                  // EN
                  if (this.existujeJazyk2) {
                    if (!this.mapaIdSkupinAMapCastiATypovZaznamovJazyk2.has(typ.idSkupina)) {
                      let mapaCastiSkupinAJejTypov: Map<number, TypZaznamuTextu[]> = new Map();
                      mapaCastiSkupinAJejTypov.set(index + 1, [t]);
                      this.mapaIdSkupinAMapCastiATypovZaznamovJazyk2.set(typ.idSkupina, mapaCastiSkupinAJejTypov);
                    } else {
                      const mapa = this.mapaIdSkupinAMapCastiATypovZaznamovJazyk2.get(typ.idSkupina);
                      // mapa.set(index + 1, );
                      if (!mapa.has(index + 1)) {
                        mapa.set(index + 1, [t]);
                      } else {
                        mapa.get(index + 1).push(t);
                      }
                    }
                  }

                  // jazyk 3
                  if (this.existujeJazyk3) {
                    if (!this.mapaIdSkupinAMapCastiATypovZaznamovJazyk3.has(typ.idSkupina)) {
                      let mapaCastiSkupinAJejTypov: Map<number, TypZaznamuTextu[]> = new Map();
                      mapaCastiSkupinAJejTypov.set(index + 1, [t]);
                      this.mapaIdSkupinAMapCastiATypovZaznamovJazyk3.set(typ.idSkupina, mapaCastiSkupinAJejTypov);
                    } else {
                      const mapa = this.mapaIdSkupinAMapCastiATypovZaznamovJazyk3.get(typ.idSkupina);
                      // mapa.set(index + 1, );
                      if (!mapa.has(index + 1)) {
                        mapa.set(index + 1, [t]);
                      } else {
                        mapa.get(index + 1).push(t);
                      }
                    }
                  }

                  // jazyk 1
                  if (!this.mapaIdTypovAPoziciiVCastiSkupiny.has(t.id)) {
                    this.mapaIdTypovAPoziciiVCastiSkupiny.set(t.id, [poradie]);
                  } else {
                    this.mapaIdTypovAPoziciiVCastiSkupiny.get(t.id).push(poradie);
                  }

                  // jazyk 2
                  if (this.existujeJazyk2) {
                    if (!this.mapaIdTypovAPoziciiVCastiSkupinyJazyk2.has(t.id)) {
                      this.mapaIdTypovAPoziciiVCastiSkupinyJazyk2.set(t.id, [poradie]);
                    } else {
                      this.mapaIdTypovAPoziciiVCastiSkupinyJazyk2.get(t.id).push(poradie);
                    }
                  }

                  // jazyk 3
                  if (this.existujeJazyk3) {
                    if (!this.mapaIdTypovAPoziciiVCastiSkupinyJazyk3.has(t.id)) {
                      this.mapaIdTypovAPoziciiVCastiSkupinyJazyk3.set(t.id, [poradie]);
                    } else {
                      this.mapaIdTypovAPoziciiVCastiSkupinyJazyk3.get(t.id).push(poradie);
                    }
                  }

                } else {
                  break;
                }
              }

            }
            // potrebujeme sa posunut v zozname typov zaznamov textov o opakovane polozky v skupine
            i = i + posun;

            this.mapaPoctovZaznamovPreSkupinu.set(typ.idSkupina, posun);

            // tuto mapu (this.mapaIdSkupinACastiSkupin) potrebujeme kvoli iteracii
            // cez jednotlive casti skupiny pri skupinovom opakovani
            // SK
            for (const idSkupina of this.mapaIdSkupinAPoctovOpakovani.keys()) {
              for (let i = 0; i < this.mapaIdSkupinAPoctovOpakovani.get(idSkupina); i++) {
                if (!this.mapaIdSkupinACastiSkupin.has(idSkupina)) {
                  this.mapaIdSkupinACastiSkupin.set(idSkupina, [i+1]);
                } else {
                  let pole = this.mapaIdSkupinACastiSkupin.get(idSkupina);
                  if (!pole.find(p => p === (i+1))) {
                    this.mapaIdSkupinACastiSkupin.get(idSkupina).push(i+1);
                  }
                }
              }
            }

            // jazyk 2
            if (this.existujeJazyk2) {
              for (const idSkupina of this.mapaIdSkupinAPoctovOpakovaniJazyk2.keys()) {
                for (let i = 0; i < this.mapaIdSkupinAPoctovOpakovaniJazyk2.get(idSkupina); i++) {
                  if (!this.mapaIdSkupinACastiSkupinJazyk2.has(idSkupina)) {
                    this.mapaIdSkupinACastiSkupinJazyk2.set(idSkupina, [i+1]);
                  } else {
                    let pole = this.mapaIdSkupinACastiSkupinJazyk2.get(idSkupina);
                    if (!pole.find(p => p === (i+1))) {
                      this.mapaIdSkupinACastiSkupinJazyk2.get(idSkupina).push(i+1);
                    }
                  }
                }
              }
            }

            // jazyk 3
            if (this.existujeJazyk3) {
              for (const idSkupina of this.mapaIdSkupinAPoctovOpakovaniJazyk3.keys()) {
                for (let i = 0; i < this.mapaIdSkupinAPoctovOpakovaniJazyk3.get(idSkupina); i++) {
                  if (!this.mapaIdSkupinACastiSkupinJazyk3.has(idSkupina)) {
                    this.mapaIdSkupinACastiSkupinJazyk3.set(idSkupina, [i+1]);
                  } else {
                    let pole = this.mapaIdSkupinACastiSkupinJazyk3.get(idSkupina);
                    if (!pole.find(p => p === (i+1))) {
                      this.mapaIdSkupinACastiSkupinJazyk3.get(idSkupina).push(i+1);
                    }
                  }
                }
              }
            }


          } else {

            // NESKUPINOVE OPAKOVANIE

            // jazyk 1
            let formArrayJazyk1 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk1);
            for (let index = 0; index < typ.minPocet; index++) {
              formArrayJazyk1.push(new UntypedFormControl({value: typ.textPredvoleny,
                disabled: disablujPolozku}));
            }
            // PODPROGRAM
            if ((this.appStateService.jeOpakovaniePodprogramu(typ)) && !typ.minPocet) {
              formArrayJazyk1.push(new UntypedFormControl({value: typ.textPredvoleny,
                disabled: disablujPolozku}));
            }
            // toto musime urobit kvoli specialnemu pristupu k opakovaniu v autocomplete
            if (typ.idDruhZaznamuTextu === this.AUTOCOMPLETE) {
              this.mapaIdTypovAPoliAutocompletov.set(typ.id, formArrayJazyk1);
            }

            // jazyk 2
            if (this.existujeJazyk2) {
              let formArrayJazyk2 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk2);
              for (let index = 0; index < typ.minPocet; index++) {
                formArrayJazyk2.push(new UntypedFormControl({value: typ.textPredvolenyJazyk2,
                  disabled: disablujPolozku}));
              }
              if ((this.appStateService.jeOpakovaniePodprogramu(typ)) && !typ.minPocet) {
                formArrayJazyk2.push(new UntypedFormControl({value: typ.textPredvolenyJazyk2,
                  disabled: disablujPolozku}));
              }
              if (typ.idDruhZaznamuTextu === this.AUTOCOMPLETE) {
                this.mapaIdTypovAPoliAutocompletovJazyk2.set(typ.id, formArrayJazyk2);
              }
            }

            // jazyk 3
            if (this.existujeJazyk3) {
              let formArrayJazyk3 = <UntypedFormArray>this.formularFormGroup.get(menoArrayControlsuJazyk3);
              for (let index = 0; index < typ.minPocet; index++) {
                formArrayJazyk3.push(new UntypedFormControl({value: typ.textPredvolenyJazyk3,
                  disabled: disablujPolozku}));
              }
              if ((this.appStateService.jeOpakovaniePodprogramu(typ)) && !typ.minPocet) {
                formArrayJazyk3.push(new UntypedFormControl({value: typ.textPredvolenyJazyk3,
                  disabled: disablujPolozku}));
              }
              if (typ.idDruhZaznamuTextu === this.AUTOCOMPLETE) {
                this.mapaIdTypovAPoliAutocompletovJazyk3.set(typ.id, formArrayJazyk3);
              }
            }

          }

          // this.formularFormGroup.addControl(menoControlsu, new FormControl(''));
        } else {

          // NEOPAKOVANE POLOZKY

          // jazyk 1
          const menoControlsu = 'name_' + typ.id + '_' + this.jazyk1;
          // const haha = new FormControl(typ.textPredvoleny);
          // haha.disable();
          // const disablujPolozku = !this.data.pouzivatelMozeEditovatUroven2;
          this.formularFormGroup.addControl(menoControlsu,
            new UntypedFormControl({value: typ.textPredvoleny, disabled: disablujPolozku}));
          // this.formularFormGroup.addControl(menoControlsu, this.formBuilder.array([]));

          // jazyk2
          if (this.existujeJazyk2) {
            const menoControlsuJazyk2 = 'name_' + typ.id + '_' + this.jazyk2;
            this.formularFormGroup.addControl(menoControlsuJazyk2,
              new UntypedFormControl({value: typ.textPredvolenyJazyk2, disabled: disablujPolozku}));
          }

          // jazyk3
          if (this.existujeJazyk3) {
            const menoControlsuJazyk3 = 'name_' + typ.id + '_' + this.jazyk3;
            this.formularFormGroup.addControl(menoControlsuJazyk3,
              new UntypedFormControl({value: typ.textPredvolenyJazyk3, disabled: disablujPolozku}));
          }

        }

      }

      if (this.data.idDruhDokumentu === this.DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK) {
        if (this.idStudProgram > 0) {
          this.appStateService.fetchZaznamyTextuData(null, this.idStudProgram, null,
            this.data.idDruhDokumentu, this.idTypDokumentuTextu,
            null);
        } else if (this.idPodprogram > 0) {
          this.appStateService.fetchZaznamyTextuData(null, null, this.idPodprogram,
            this.data.idDruhDokumentu, this.idTypDokumentuTextu,
            null);
        }
      } else if (this.data.idDruhDokumentu === this.DOKUMENT_TEXT_OSOBY) {
        this.appStateService.fetchZaznamyTextuData(this.idOsoby, null, null,
          this.data.idDruhDokumentu, this.idTypDokumentuTextu, null);
      }

    });

    // dotiahneme si data z DB, ak uz nahodou nejake "zaznamy textu (STZaznamTextu)"
    // pre pouzivatela existuju - predvyplnime nimi formular
    // this.appStateService.fetchZaznamyTextuData(2479, null, this.kodJazykRadioBox);
    // chceme to urobit iba raz, pri refreshnuti formulara
    this.zaznamyTextovDataSubscription = this.appStateService.zaznamyTextuDataFetched
    .subscribe((data: ZaznamTextu[]) => {

      if (data) {
        this.poleIdciekZaznamov = data.map(z => z.idTypZaznamTextu);
      }

      for (const z of data) {

        // this.mapaIdTypovAExistencieZaznamov.set(z.idTypZaznamTextu, true);
        // ak je atribut podprogram === 1, potrebujeme si ulozit info o tom, ktore stud. programy podprogramu su zaznamu priradene
        if (this.idPodprogram > 0 && z.poradie
          && this.mapaIdTypovAHodnotAtributuPodprogram.get(z.idTypZaznamTextu)
          && this.mapaIdTypovAHodnotAtributuPodprogram.get(z.idTypZaznamTextu)
            === this.OPAKOVANA_POLOZKA_PODPROGRAMU) {

          // v tejto mape budeme uchovavat poradia jednotlivych zaznamov podprogramu pre typ a jazyk
          this.naplnMapuIdTypovAMapJazykovAPoliPoradiZaznamovPodprogramu(z);

          this.naplnMapuIdTypovAMapJazykovAMapPoradiAPoliStudProgramovZaznamuPodprogramu(z);

        }

        if (z.podprogram) {
          if (!this.appStateService.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.get(z.idTypZaznamTextu)) {
            const mapaJazykovAZaznamovsPodprogramami: Map<string, ZaznamTextu[]> = new Map();
            mapaJazykovAZaznamovsPodprogramami.set(z.kodJazyk, [z]);
            this.appStateService.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.set(z.idTypZaznamTextu, mapaJazykovAZaznamovsPodprogramami);
          } else {
            const mapaJazykovAZaznamovsPodprogramami = this.appStateService.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.get(z.idTypZaznamTextu);
            if (!mapaJazykovAZaznamovsPodprogramami.get(z.kodJazyk)) {
              mapaJazykovAZaznamovsPodprogramami.set(z.kodJazyk, [z]);
            } else {
              mapaJazykovAZaznamovsPodprogramami.get(z.kodJazyk).push(z);
            }

          }
        }

        this.naplnitMapyPreStupneATypyStudia(z);

      }

      // z nejakeho zahadneho dovodu sa bez tejto funkcie (setTimeout) nestihnu dotiahnut vsetky veci do map stupnov a typov studia
      setTimeout(() => {

        if (this.niektoraZMapPreVariant1JeNaplnena) {
          this.appStateService.mapyPreVariant1Naplnene.next(true);
        }

      }, 0);



      this.zaznamyTextovZDB = data;
      this.appStateService.zaznamyTextovZDB = data;
      // console.log('Zaznamy textov prisli z DB: ' + JSON.stringify(data));

      if (!this.formularJePredvyplneny) {
        this.vytvorJSONIdTypAText(data);
        this.vyplnFormular();
        this.formularJePredvyplneny = true;
        this.nastavSledovanieZmien();
        this.spinner = false;
        // console.log('spinner vypnut!');
      }

    });


    this.appStateService.spinnerChanged
      .subscribe((spinnerZapnut) => {
        this.spinner = spinnerZapnut ? true : false;
        // console.log('spinner v spinnerChanged: ' + this.spinner);
      });


    // 1 - Opis študijného programu; 2 - Vnútorná hodnotiaca správa študijného programu;
    // TODO:
    // this.appStateService.fetchTypZaznamuTextuData(this.idTypDokumentuTextu);

    // const menoControlsu:string = 'aktualnaStranaControl';
    this.formularFormGroup.addControl('aktualnaStranaControl', new UntypedFormControl(this.aktualnaStrana));

    const aktualnaStranaControl = <UntypedFormControl>(this.formularFormGroup.get('aktualnaStranaControl'));

    this.aktualnaStranaSubscription = aktualnaStranaControl.valueChanges
    .subscribe((value: string) => {
      // console.log('zvolenaStranaSubscription: ' + value);
      this.disablovatNavigacneButtonyKvoliZadaniuStrany = true;
      const strana = Number(value);
      if (!isNaN(strana) && strana > 0 && strana <= this.pocetStran) {
        this.disablujPotvrdzovaciButton = false;
        // console.log('this.disablujPotvrdzovaciButton' + this.disablujPotvrdzovaciButton);
        this.zvolenaStrana = strana;
        // this.posunNaStranu(strana, false);
      } else {
        this.disablujPotvrdzovaciButton = true;
      }
    });


    this.appStateService.pocetSkopirovanychPoloziekDataFetched
    .subscribe((pocetData) => {
      this.pocetSkopirovanychPoloziek = pocetData;
      // console.log('Pocet skopcenych poloziek je : ' + pocetData)
      this.zobrazDialogSPoctomSkopirovanychPoloziek(this.pocetSkopirovanychPoloziek);
      // window.location.reload();
    });


  }

  getTypyZaznamovTextuNaStrane(strana: number): TypZaznamuTextu[] {
    let result: TypZaznamuTextu[] = [];
    if (this.typyZaznamuTextu) {
      result = this.typyZaznamuTextu.filter((z:TypZaznamuTextu) => {
        z.strana === strana;
      });
    }
    // console.log('Typy zaznamu textu: ' + this.typyZaznamuTextu);
    return result;
  }

  getPoleStran(): number[] {
    // let poleStran = data.map((typ: TypZaznamuTextu) => {
    //     return typ.strana;
    //   });

    // return poleStran.filter((strana:number, index) => {
    //   poleStran.indexOf(strana) === index;
    // });
    let poleStran = [];
    for (const typ of this.typyZaznamuTextu) {
      if (!poleStran.includes(typ.strana)) {
        poleStran.push(typ.strana);
      }
    }
    return poleStran;
  }

  getPocetStran(): number {
    return this.poleStran.length;
  }

  // vytvorime JSON s dvojicami {'idTypZaznamuTextu': 'text'}
  vytvorJSONIdTypAText(zaznamyTextu: ZaznamTextu[]) {

    let result = {};
    let idckaDatumovychPoloziek = [];
    // let idckaSkupinovychPoloziek = [];
    let mapaIdciekTypovPoloziekASkupin: Map<number,number> = new Map();
    let mapaIdciekSkupinATypov: Map<number,number[]> = new Map();

    let mapaIdciekSkupinAZaznamovTextu: Map<number,ZaznamTextu[]> = new Map();
    let mapaIdciekSkupinAZaznamovTextuJazyk2: Map<number,ZaznamTextu[]> = new Map();
    let mapaIdciekSkupinAZaznamovTextuJazyk3: Map<number,ZaznamTextu[]> = new Map();

    let existujeOpakovanaPolozka = false;

    let mapaIdciekATypov: Map<number, TypZaznamuTextu> = new Map();

    for (const typ of this.typyZaznamuTextu) {
      if (typ.idTypObjektu === this.DATE) {
        idckaDatumovychPoloziek.push(typ.id);
      }
      if (typ.idDruhZaznamuTextu === this.POLOZKA && typ.idSkupina) {
        mapaIdciekTypovPoloziekASkupin.set(typ.id, typ.idSkupina);
        if (!mapaIdciekSkupinATypov.get(typ.idSkupina)) {
          mapaIdciekSkupinATypov.set(typ.idSkupina, [typ.id]);
        } else {
          mapaIdciekSkupinATypov.get(typ.idSkupina).push(typ.id);
        }
      }
      mapaIdciekATypov.set(typ.id, typ);

      if (!existujeOpakovanaPolozka
        && (typ.opakovanie === 'A'
          || (this.appStateService.jeOpakovaniePodprogramu(typ)))
        && typ.idDruhZaznamuTextu === this.POLOZKA) {

        existujeOpakovanaPolozka = true;
      }
    }

    // console.log('mapaPoctovOpakovani: ' + mapaPoctovOpakovaniPreTypZaznamu);

    let idTyp: number;
    let typ: TypZaznamuTextu;

    let poleOpakovanychPoloziek: string[] = [];
    let poleOpakovanychPoloziekJazyk2: string[] = [];
    let poleOpakovanychPoloziekJazyk3: string[] = [];

    let pocetZaznamovPreNeskupOpakovanyTyp = 0;
    let pocetZaznamovPreNeskupOpakovanyTypJazyk2 = 0;
    let pocetZaznamovPreNeskupOpakovanyTypJazyk3 = 0;

    let mapaPoctovNeskupinovychOpakovaniPreTypZaznamu: Map<number, number> = new Map();
    let mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk2: Map<number, number> = new Map();
    let mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk3: Map<number, number> = new Map();

    // toto potrebujeme pre skupinove polozky
    if (mapaIdciekTypovPoloziekASkupin.size > 0 || existujeOpakovanaPolozka) {

      for (const z of zaznamyTextu) {

        if (mapaIdciekTypovPoloziekASkupin.has(z.idTypZaznamTextu)) {
          const idSkupina = mapaIdciekTypovPoloziekASkupin.get(z.idTypZaznamTextu);
          if (z.kodJazyk === this.jazyk1) {
            // VETVA pre 1. jazyk
            if (!mapaIdciekSkupinAZaznamovTextu.has(idSkupina)) {
              mapaIdciekSkupinAZaznamovTextu.set(idSkupina, [z]);
            } else {
              mapaIdciekSkupinAZaznamovTextu.get(idSkupina).push(z);
            }
          } else if (z.kodJazyk === this.jazyk2) {
            // VETVA pre 2. jazyk
            if (!mapaIdciekSkupinAZaznamovTextuJazyk2.has(idSkupina)) {
              mapaIdciekSkupinAZaznamovTextuJazyk2.set(idSkupina, [z]);
            } else {
              mapaIdciekSkupinAZaznamovTextuJazyk2.get(idSkupina).push(z);
            }
          } else if (z.kodJazyk === this.jazyk3) {
            // VETVA pre 3. jazyk
            if (!mapaIdciekSkupinAZaznamovTextuJazyk3.has(idSkupina)) {
              mapaIdciekSkupinAZaznamovTextuJazyk3.set(idSkupina, [z]);
            } else {
              mapaIdciekSkupinAZaznamovTextuJazyk3.get(idSkupina).push(z);
            }
          }


        }

        // ak nejde o skupinovu polozku, iba opakovanu
        else if (z.poradie) {

          if (z.kodJazyk === this.jazyk1) {
            // VETVA pre jazyk 1
            if (!mapaPoctovNeskupinovychOpakovaniPreTypZaznamu.has(z.idTypZaznamTextu)) {
              mapaPoctovNeskupinovychOpakovaniPreTypZaznamu.set(z.idTypZaznamTextu, 1);
            } else {
              mapaPoctovNeskupinovychOpakovaniPreTypZaznamu.set(z.idTypZaznamTextu,
                mapaPoctovNeskupinovychOpakovaniPreTypZaznamu.get(z.idTypZaznamTextu) + 1);
            }
          } else if (z.kodJazyk === this.jazyk2) {
            // VETVA pre jazyk 2
            if (!mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk2.has(z.idTypZaznamTextu)) {
              mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk2.set(z.idTypZaznamTextu, 1);
            } else {
              mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk2.set(z.idTypZaznamTextu,
                mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk2.get(z.idTypZaznamTextu) + 1);
            }
          } else if (z.kodJazyk === this.jazyk3) {
            // VETVA pre jazyk 3
            if (!mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk3.has(z.idTypZaznamTextu)) {
              mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk3.set(z.idTypZaznamTextu, 1);
            } else {
              mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk3.set(z.idTypZaznamTextu,
                mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk3.get(z.idTypZaznamTextu) + 1);
            }
          }

        }

      }
    }

    let skupinovePolozkyDoFormularaDoplneneMap: Map<number,boolean> = new Map();
    let skupinovePolozkyVJazyku2DoFormularaDoplneneMap: Map<number,boolean> = new Map();
    let skupinovePolozkyVJazyku3DoFormularaDoplneneMap: Map<number,boolean> = new Map();

    // potrebujeme zotriedit polozky - na servri je to zlozite
    zaznamyTextu.sort((zt1, zt2) => {
      return mapaIdciekATypov.get(zt1.idTypZaznamTextu).poradie - mapaIdciekATypov.get(zt2.idTypZaznamTextu).poradie;
    });

    for (const zaznam of zaznamyTextu) {

      /*
        spms 122923 - tuto kontrolu potrebujeme kvoli problemu vyplnania formulara
        zaznamami v jazyku, ktory formular "nepodporuje" - moze sa totiz stat,
        ze existuju v DB zaznamyTextu v EN jazyku a nasledne obmedzeniami pre dany
        stud. program, formu, stupen EN jazyk vypnu
      */
      if (!this.data.jazykyFormulara.includes(zaznam.kodJazyk)) {
        continue;
      }

      if (!idTyp) {
        idTyp = zaznam.idTypZaznamTextu;
      }

      typ = mapaIdciekATypov.get(idTyp);

      // OPAKOVANE POLOZKY (alebo polozky podprogramu, kde podprogram === 1 a sucasne this.idPodprogram > 0)
      if (zaznam.poradie) {

        // VETVA PRE SKUPINOVY ZAZNAM...
        if (mapaIdciekTypovPoloziekASkupin.has(zaznam.idTypZaznamTextu)) {

          const idSkupina = mapaIdciekTypovPoloziekASkupin.get(zaznam.idTypZaznamTextu);
          const name = 'name_' + idSkupina + '_' + zaznam.kodJazyk;

          if (zaznam.kodJazyk === this.jazyk1) {
            // SK VETVA

            // ak skupinu uz mame vybavenu, prejdeme na dalsi krok (zaznam) v cykle
            if (skupinovePolozkyDoFormularaDoplneneMap.get(idSkupina)) {
              idTyp = null;
              continue;
            }

            let zaznamySkupinoveZDB: ZaznamTextu[] = mapaIdciekSkupinAZaznamovTextu.get(idSkupina);
            zaznamySkupinoveZDB.sort((a, b) => {
              return a.poradie - b.poradie;
            });

            // POCET VSETKYCH POLOZIEK V SKUPINE (default je ("minPocet" * pocet typov v casti skupiny))
            const pocetVsetkychPoloziekVSkupine =
              this.getPocetSkupinovychOpakovaniVoFormulari(idSkupina, mapaIdciekSkupinATypov,
                zaznamySkupinoveZDB)

            // potrebujeme doplnit do formulara polozky (!aj prazdne!)
            const zaznamyTextovDoFormularaZDB = this.getSkupinoveZaznamyTextuDoFormulara(idSkupina,
              pocetVsetkychPoloziekVSkupine, mapaIdciekSkupinATypov, zaznamySkupinoveZDB);

            // potrebujeme do formulara doplnit polozky, ktore su v DB, ale vo formulari zatial nie
            let poleZaznamovVoFormulari: UntypedFormArray = <UntypedFormArray>this.formularFormGroup.get(name);
            if (poleZaznamovVoFormulari.length < zaznamyTextovDoFormularaZDB.length) {
              let poleTypovNaPridanie: TypZaznamuTextu[] = [];
              for (let i = poleZaznamovVoFormulari.length; i < zaznamyTextovDoFormularaZDB.length; i++) {
                const typ = mapaIdciekATypov.get(zaznamyTextovDoFormularaZDB[i].idTypZaznamTextu);
                poleTypovNaPridanie.push(typ);
              }
              if (poleTypovNaPridanie.length > 0) {
                const idSkupina = poleTypovNaPridanie[0].idSkupina;
                this.pridatSkupinoveOpakovanie(idSkupina,
                  this.mapaIdSkupinAMaxPoctovOpakovani.get(idSkupina),
                  zaznam.kodJazyk, true,
                  poleTypovNaPridanie);
              }

              skupinovePolozkyDoFormularaDoplneneMap.set(idSkupina, true);
            }

            // vlozenie formularovych poloziek do objektu, ktory sa neskor vlozi do formulara.

            // pre comboboxy (select) ulozime aktualnu hodnotu, ak sa nenachadza v ciselniku,
            // z ktoreho sa combobox naplna (napr. ak je uz neplatna)
            if (typ.idTypObjektu === this.SELECT) {
              if (!this.polozkaJeVCiselniku(zaznam.text, typ, this.jazyk1)) {
                typ.polozkyCiselnika.push(zaznam.text);
              }
            }

            result[name] = zaznamyTextovDoFormularaZDB.map(z => z.text);

            // console.log(this.formularFormGroup);

            idTyp = null;

          } else if (zaznam.kodJazyk === this.jazyk2) {

            // VETVA pre 2. jazyk
            if (skupinovePolozkyVJazyku2DoFormularaDoplneneMap.get(idSkupina)) {
              idTyp = null;
              continue;
            }

            // let values: string[] = [];
            let zaznamySkupinoveZDBJazyk2: ZaznamTextu[] = mapaIdciekSkupinAZaznamovTextuJazyk2.get(idSkupina);
            zaznamySkupinoveZDBJazyk2.sort((a, b) => {
              return a.poradie - b.poradie;
            });

            // POCET OPAKOVANI V SKUPINE (default je "minPocet" * pocet opakovani v casti skupiny)
            const pocetVsetkychPoloziekVSkupine =
              this.getPocetSkupinovychOpakovaniVoFormulari(idSkupina, mapaIdciekSkupinATypov,
                zaznamySkupinoveZDBJazyk2)

            // potrebujeme doplnit do formulara polozky (!aj prazdne!)
            const zaznamyTextovDoFormularaJazyk2 = this.getSkupinoveZaznamyTextuDoFormulara(idSkupina,
              pocetVsetkychPoloziekVSkupine, mapaIdciekSkupinATypov, zaznamySkupinoveZDBJazyk2);

            // potrebujeme do formulara doplnit polozky, ktore su v DB, ale vo formulari zatial nie
            let poleZaznamovVoFormulari: UntypedFormArray = <UntypedFormArray>this.formularFormGroup.get(name);
            if (poleZaznamovVoFormulari.length < zaznamyTextovDoFormularaJazyk2.length) {
              let poleTypovNaPridanie: TypZaznamuTextu[] = [];
              for (let i = poleZaznamovVoFormulari.length; i < zaznamyTextovDoFormularaJazyk2.length; i++) {
                const typ = mapaIdciekATypov.get(zaznamyTextovDoFormularaJazyk2[i].idTypZaznamTextu);
                poleTypovNaPridanie.push(typ);
              }
              if (poleTypovNaPridanie.length > 0) {
                const idSkupina = poleTypovNaPridanie[0].idSkupina;
                this.pridatSkupinoveOpakovanie(idSkupina,
                  this.mapaIdSkupinAMaxPoctovOpakovani.get(idSkupina),
                  zaznam.kodJazyk, true,
                  poleTypovNaPridanie);
              }

              skupinovePolozkyVJazyku2DoFormularaDoplneneMap.set(idSkupina, true);
            }

            // pre comboboxy (select) ulozime aktualnu hodnotu, ak sa nenachadza v ciselniku,
            // z ktoreho sa combobox naplna (napr. ak je uz neplatna)
            if (typ.idTypObjektu === this.SELECT) {
              if (!this.polozkaJeVCiselniku(zaznam.text, typ, this.jazyk2)) {
                typ.polozkyCiselnikaJazyk2.push(zaznam.text);
              }
            }

            // vlozenie formularovych poloziek do objektu, ktory sa neskor vlozi do formulara
            result[name] = zaznamyTextovDoFormularaJazyk2.map(z => z.text);

            // console.log(this.formularFormGroup);

            idTyp = null;

          } else if (zaznam.kodJazyk === this.jazyk3) {

            // VETVA pre 3. jazyk
            if (skupinovePolozkyVJazyku3DoFormularaDoplneneMap.get(idSkupina)) {
              idTyp = null;
              continue;
            }

            // let values: string[] = [];
            let zaznamySkupinoveZDBJazyk3: ZaznamTextu[] = mapaIdciekSkupinAZaznamovTextuJazyk3.get(idSkupina);
            zaznamySkupinoveZDBJazyk3.sort((a, b) => {
              return a.poradie - b.poradie;
            });

            // POCET OPAKOVANI V SKUPINE (default je "minPocet" * pocet opakovani v casti skupiny)
            const pocetVsetkychPoloziekVSkupine =
              this.getPocetSkupinovychOpakovaniVoFormulari(idSkupina, mapaIdciekSkupinATypov,
                zaznamySkupinoveZDBJazyk3)

            // potrebujeme doplnit do formulara polozky (!aj prazdne!)
            const zaznamyTextovDoFormularaJazyk3 = this.getSkupinoveZaznamyTextuDoFormulara(idSkupina,
              pocetVsetkychPoloziekVSkupine, mapaIdciekSkupinATypov, zaznamySkupinoveZDBJazyk3);

            // potrebujeme do formulara doplnit polozky, ktore su v DB, ale vo formulari zatial nie
            let poleZaznamovVoFormulari: UntypedFormArray = <UntypedFormArray>this.formularFormGroup.get(name);
            if (poleZaznamovVoFormulari.length < zaznamyTextovDoFormularaJazyk3.length) {
              let poleTypovNaPridanie: TypZaznamuTextu[] = [];
              for (let i = poleZaznamovVoFormulari.length; i < zaznamyTextovDoFormularaJazyk3.length; i++) {
                const typ = mapaIdciekATypov.get(zaznamyTextovDoFormularaJazyk3[i].idTypZaznamTextu);
                poleTypovNaPridanie.push(typ);
              }
              if (poleTypovNaPridanie.length > 0) {
                const idSkupina = poleTypovNaPridanie[0].idSkupina;
                this.pridatSkupinoveOpakovanie(idSkupina,
                  this.mapaIdSkupinAMaxPoctovOpakovani.get(idSkupina),
                  zaznam.kodJazyk, true,
                  poleTypovNaPridanie);
              }

              skupinovePolozkyVJazyku3DoFormularaDoplneneMap.set(idSkupina, true);
            }

            // pre comboboxy (select) ulozime aktualnu hodnotu, ak sa nenachadza v ciselniku,
            // z ktoreho sa combobox naplna (napr. ak je uz neplatna)
            if (typ.idTypObjektu === this.SELECT) {
              if (!this.polozkaJeVCiselniku(zaznam.text, typ, this.jazyk3)) {
                typ.polozkyCiselnikaJazyk3.push(zaznam.text);
              }
            }

            // vlozenie formularovych poloziek do objektu, ktory sa neskor vlozi do formulara
            result[name] = zaznamyTextovDoFormularaJazyk3.map(z => z.text);

            // console.log(this.formularFormGroup);

            idTyp = null;

          }

        // VETVA PRE OPAKOVANY NESKUPINOVY ZAZNAM alebo pre typ, kde atribut podprogram > 0
        // kontrola, aby sme si boli isti, ze riesime zaznamy pre opakovane typy (kontrola zaznam.opakovanie === 'A' zjavne nestaci)
        } else if (mapaIdciekATypov.get(zaznam.idTypZaznamTextu)
              &&
              (mapaIdciekATypov.get(zaznam.idTypZaznamTextu).opakovanie === 'A'
          || (this.appStateService.jeOpakovaniePodprogramu(mapaIdciekATypov.get(zaznam.idTypZaznamTextu))))) {

          const typ = mapaIdciekATypov.get(zaznam.idTypZaznamTextu);

          // VETVA pre jazyk 1
          if (zaznam.kodJazyk === this.jazyk1) {
            // OPAKOVANE POLOZKY - toto vsetko nizsie tu je kvoli tomu;
            // potrebujeme pre kazdy typ pocet opakovani
            if (zaznam.idTypZaznamTextu === idTyp) {
              pocetZaznamovPreNeskupOpakovanyTyp++;
              // console.log('som dnuka');
              poleOpakovanychPoloziek.push(zaznam.text);

              // TODO: naplnime mapu, ktora nesie info o tom, ktore polozky su vyplnene pri prvom zobrazeni formulara
              if (this.idStudProgram > 0 && typ.podprogram && typ.podprogram > 0
                && zaznam.idPodprogramSpolocnaPolozka) {

                this.pridajPolozkuDoMapyVyplnenychPoloziek(idTyp, zaznam.kodJazyk, poleOpakovanychPoloziek.length);
              }

              // v pripade, ze je v DB viac zaznamov pre typ, ako je minPocet,
              // potrebujeme do formulara doplnit polozky manualne
              // POZOR!!! - pri podprogramoch a "opakovanych" polozkach (typ.podprogram === 1) to treba urobit inak, lebo pri tychto polozkach je vzdy "minPocet" === 0
              if (pocetZaznamovPreNeskupOpakovanyTyp > typ.minPocet
                ||
                (typ.opakovanie !== 'A'
                  && this.appStateService.jeOpakovaniePodprogramu(typ)) ){

                const name = 'name_' + zaznam.idTypZaznamTextu + '_' + zaznam.kodJazyk;
                const control = new UntypedFormControl(typ.textPredvoleny);
                (<UntypedFormArray>this.formularFormGroup.get(name)).push(control);
              }

              // ak uz sme presli vsetky opakovane polozky, ulozime ich do formulara
              if (pocetZaznamovPreNeskupOpakovanyTyp
                  === mapaPoctovNeskupinovychOpakovaniPreTypZaznamu.get(zaznam.idTypZaznamTextu)) {

                const name = 'name_' + zaznam.idTypZaznamTextu + '_' + zaznam.kodJazyk;

                // osetrime pripad podprogramovych opakovani, lebo v tomto pripade mame vo formulari jeden control navyse
                if (typ.opakovanie !== 'A'
                    && this.appStateService.jeOpakovaniePodprogramu(typ)) {

                  let formArray = <UntypedFormArray>this.formularFormGroup.get(name);
                  if (formArray.length > 1) {
                    formArray.removeAt(formArray.length - 1);
                  }
                }

                // pre comboboxy (select) ulozime aktualnu hodnotu, ak sa nenachadza v ciselniku,
                // z ktoreho sa combobox naplna (napr. ak je uz neplatna)
                if (typ.idTypObjektu === this.SELECT) {
                  if (!this.polozkaJeVCiselniku(zaznam.text, typ, this.jazyk1)) {
                    typ.polozkyCiselnika.push(zaznam.text);
                  }
                }

                result[name] = poleOpakovanychPoloziek;
                // console.log('result 1: ' + result[name]);
                poleOpakovanychPoloziek = [];
                idTyp = null;
                pocetZaznamovPreNeskupOpakovanyTyp = 0;
                continue;
              } else {
                // pre comboboxy (select) ulozime aktualnu hodnotu, ak sa nenachadza v ciselniku,
                // z ktoreho sa combobox naplna (napr. ak je uz neplatna)
                if (typ.idTypObjektu === this.SELECT) {
                  if (!this.polozkaJeVCiselniku(zaznam.text, typ, this.jazyk1)) {
                    typ.polozkyCiselnika.push(zaznam.text);
                  }
                }

                continue;
              }
            }
          }
          // VETVA pre jazyk2
          else if (zaznam.kodJazyk === this.jazyk2) {
            // OPAKOVANE POLOZKY - toto vsetko nizsie tu je kvoli tomu
            // potrebujeme pre kazdy typ pocet opakovani
            // TODO: rozlisovat opakovania pri jednotlivych jazykoch
            if (zaznam.idTypZaznamTextu === idTyp) {
              pocetZaznamovPreNeskupOpakovanyTypJazyk2++;
              // console.log('som dnuka');
              poleOpakovanychPoloziekJazyk2.push(zaznam.text);

              // v pripade, ze je v DB viac zaznamov pre typ, ako je minPocet,
              // potrebujeme do formulara doplnit polozky manualne
              const name = 'name_' + zaznam.idTypZaznamTextu + '_' + zaznam.kodJazyk;
              if (pocetZaznamovPreNeskupOpakovanyTypJazyk2 > typ.minPocet
                  ||
                  (typ.opakovanie !== 'A'
                    && this.appStateService.jeOpakovaniePodprogramu(typ))) {

                const control = new UntypedFormControl(typ.textPredvolenyJazyk2);
                (<UntypedFormArray>this.formularFormGroup.get(name)).push(control);
              }

              // ak uz sme presli vsetky opakovane polozky, ulozime ich do formulara
              if (pocetZaznamovPreNeskupOpakovanyTypJazyk2 === mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk2.get(zaznam.idTypZaznamTextu)) {

                // osetrime pripad podprogramovych opakovani, lebo v tomto pripade mame vo formulari jednen control navyse
                if (typ.opakovanie !== 'A'
                    && this.appStateService.jeOpakovaniePodprogramu(typ)) {

                  let formArray = <UntypedFormArray>this.formularFormGroup.get(name);
                  if (formArray.length > 1) {
                    formArray.removeAt(formArray.length - 1);
                  }
                }

                result[name] = poleOpakovanychPoloziekJazyk2;
                // console.log('result 1: ' + result[name]);
                poleOpakovanychPoloziekJazyk2 = [];
                idTyp = null;
                pocetZaznamovPreNeskupOpakovanyTypJazyk2 = 0;
                continue;
              } else {
                continue;
              }
            }
          }
          else if (zaznam.kodJazyk === this.jazyk3) {
            // OPAKOVANE POLOZKY - toto vsetko nizsie tu je kvoli tomu
            // potrebujeme pre kazdy typ pocet opakovani
            // TODO: rozlisovat opakovania pri jednotlivych jazykoch
            if (zaznam.idTypZaznamTextu === idTyp) {
              pocetZaznamovPreNeskupOpakovanyTypJazyk3++;
              // console.log('som dnuka');
              poleOpakovanychPoloziekJazyk3.push(zaznam.text);

              // v pripade, ze je v DB viac zaznamov pre typ, ako je minPocet,
              // potrebujeme do formulara doplnit polozky manualne
              const name = 'name_' + zaznam.idTypZaznamTextu + '_' + zaznam.kodJazyk;
              if (pocetZaznamovPreNeskupOpakovanyTypJazyk3 > typ.minPocet
                  ||
                  (typ.opakovanie !== 'A'
                    && this.appStateService.jeOpakovaniePodprogramu(typ)) ){

                const control = new UntypedFormControl(typ.textPredvolenyJazyk3);
                (<UntypedFormArray>this.formularFormGroup.get(name)).push(control);
              }

              // ak uz sme presli vsetky opakovane polozky, ulozime ich do formulara
              if (pocetZaznamovPreNeskupOpakovanyTypJazyk3 === mapaPoctovNeskupinovychOpakovaniPreTypZaznamuJazyk3.get(zaznam.idTypZaznamTextu)) {

                // osetrime pripad podprogramovych opakovani, lebo v tomto pripade mame vo formulari jednen control navyse
                if (typ.opakovanie !== 'A'
                    && this.appStateService.jeOpakovaniePodprogramu(typ)) {

                  let formArray = <UntypedFormArray>this.formularFormGroup.get(name);
                  if (formArray.length > 1) {
                    formArray.removeAt(formArray.length - 1);
                  }
                }

                result[name] = poleOpakovanychPoloziekJazyk3;
                // console.log('result 1: ' + result[name]);
                poleOpakovanychPoloziekJazyk3 = [];
                idTyp = null;
                pocetZaznamovPreNeskupOpakovanyTypJazyk3 = 0;
                continue;
              } else {
                continue;
              }
            }
          }

          // potrebujeme si ulozit informaciu o stud. programoch podprogramu pre zaznam
          // if (zaznam.studijneProgramy) {
          //   let mapaPoradiAStudProgramov: Map<number, StudijnyProgram[]> = new Map();
          //   mapaPoradiAStudProgramov.set(zaznam.poradie, zaznam.studijneProgramy);
          //   this.appStateService.mapaIdTypovAMapPoradiAStudProgramovZaznamov.set(zaznam.idTypZaznamTextu,
          //     mapaPoradiAStudProgramov);
          // }


        } else {
          // tato vetva je tu len kvoli zlym datam v STZaznamTextu, kedy aj pri
          // neopakovanych zaznamoch sa obcas vyskytlo vyplnene "poradie" (napr. polozka "email" u pouzivatela "Lukac").
          // AK NEJDE O OPAKOVANY ANI SKUPINOVY ZAZNAM:
          const name = 'name_' + zaznam.idTypZaznamTextu + '_' + zaznam.kodJazyk;
          if (mapaIdciekATypov.get(idTyp) && mapaIdciekATypov.get(idTyp).idTypObjektu === this.DATE) {
            const dateEN = this.datePipe.transform(zaznam.text, 'yyyy-MM-dd');
            result[name] = dateEN;
          } else {

            if (typ.idTypObjektu === this.SELECT) {
              if (!this.polozkaJeVCiselniku(zaznam.text, typ, zaznam.kodJazyk)) {
                switch (zaznam.kodJazyk) {
                  case this.jazyk1:
                    typ.polozkyCiselnika.push(zaznam.text);
                    // typ.polozkyCiselnika.sort();
                    break;
                  case this.jazyk2:
                    typ.polozkyCiselnikaJazyk2.push(zaznam.text);
                    // typ.polozkyCiselnikaJazyk2.sort();
                    break;
                  case this.jazyk3:
                    typ.polozkyCiselnikaJazyk3.push(zaznam.text);
                    // typ.polozkyCiselnikaJazyk3.sort();
                    break;

                  default:
                    break;
                }
              }
            }

            result[name] = zaznam.text;
          }
          idTyp = null;
       }


      } else {

        // AK NEJDE O OPAKOVANY ANI SKUPINOVY ZAZNAM
        const name = 'name_' + zaznam.idTypZaznamTextu + '_' + zaznam.kodJazyk;
        if (typ && typ.idTypObjektu === this.DATE) {
          const dateEN = this.datePipe.transform(zaznam.text, 'yyyy-MM-dd');
          result[name] = dateEN;
        } else {

          // pre comboboxy (select) ulozime aktualnu hodnotu, ak sa nenachadza v ciselniku,
          // z ktoreho sa combobox naplna (napr. ak je uz neplatna)
          if (typ.idTypObjektu === this.SELECT) {
            if (!this.polozkaJeVCiselniku(zaznam.text, typ, zaznam.kodJazyk)) {
              switch (zaznam.kodJazyk) {
                case this.jazyk1:
                  typ.polozkyCiselnika.push(zaznam.text);
                  break;
                case this.jazyk2:
                  typ.polozkyCiselnikaJazyk2.push(zaznam.text);
                  break;
                case this.jazyk3:
                  typ.polozkyCiselnikaJazyk3.push(zaznam.text);
                  break;

                default:
                  break;
              }
            }
          }

          result[name] = zaznam.text;

        }

        idTyp = null;

      }

    }

    // spms 122354 - aj nevyplnene osobne udaje treba nahradit tymi z tabulky LZOsoba osoby dokumentu
    if (this.idTypDokumentuTextu === this.TYP_DOKUMENTU_VUPCH
      || this.idTypDokumentuTextu === this.TYP_DOKUMENTU_VTC) {

        this.skontrolujAUpravVyplnenieOsobnychUdajovPreJazyk(this.kodJazykRadioBox, result);

      }

    this.zaznamyTextuZDBIdTypAText = result;

    // spms 122354 - pre dokumenty VUPCH a VTC nahradzame osobne udaje z LZOsoba, ak nie su rovnake.
    /*
      Ak sa na formulari zmenili osobne udaje (prepisali sa datami z osoby),
       pouzivatela o tom oboznamime, nech sa mu nemenia data pod rukami
       bez toho, aby o tom vedel.
    */
    this.getUpozornenieNaZmenuOsobnychUdajov();
  }

  onSubmit(): void {
    this.ulozFormularAOdosliDataNaServer(true, true, true);
  }

  ulozFormularAOdosliDataNaServer(aktivovatSpinner: boolean, zobrazitOKDialog: boolean,
    ulozitLenAktualnuStranu?: boolean) {

    if (aktivovatSpinner) {
      this.spinner = true;
    }

    // sledovane zmeny
    if (this.zmenaVSledovanychPolozkachVJazykochMapa.size > 0) {
      // this.zmenaVSledovanychPolozkach = false;
      this.aktualizujDatumPoslednejAktualizacie(ulozitLenAktualnuStranu);
    }


    // vyzbierame data z formulara
    const zaznamyTextovNaOdoslaniePole: ZaznamTextu[] =
      this.getDataFormulara( ulozitLenAktualnuStranu ? this.aktualnaStrana : null);

    // ak ukladame formular len pre aktualnu stranu, tak potrebujeme
    // do ukladaneho zoznamu doplnit aj datum poslednej aktualizacie,
    // ktory je (zrejme) na poslednej strane
    if (ulozitLenAktualnuStranu) {
      // ak som na strane, ktora obsahuje datum poslednej aktualizacie,
      // ulozi sa automaticky so stranou,
      // nepotrebujem ho teda doplnit do zoznamu ukladanych poloziek
      if (this.typDatumPoslednejAktualizacie?.strana !== this.aktualnaStrana) {
        this.pridajDatumPoslednejAktualizacieDoZoznamuNaOdoslanie(
          zaznamyTextovNaOdoslaniePole);
      }

    }

    this.appStateService.saveOrUpdateZaznamyTextuData(zaznamyTextovNaOdoslaniePole,
      this.data.idDruhDokumentu, this.idTypDokumentuTextu,
      this.idStudProgram, this.idPodprogram, this.idOsoby,
      this.kodJazykRadioBox,
       ulozitLenAktualnuStranu ? this.aktualnaStrana : null
      );

    // toto potrebujeme kvoli opakovanemu spusteniu metody "ulozFormularAOdosliDataNaServer()"
    if (this.zaznamyTextovDataSavedSubscription) {
      this.zaznamyTextovDataSavedSubscription.unsubscribe();
    }

    this.zaznamyTextovDataSavedSubscription = this.appStateService.zaznamyTextuDataSaved
      .subscribe((data) => {

        this.zaznamyTextovZDB = data;
        this.appStateService.zaznamyTextovZDB = data;

        if (zobrazitOKDialog) {
          this.zobrazOKDialog(this.translateService.instant("Formulár bol uložený."));
        }
        this.spinner = false;

      });

  }

  // logiku som presunul na server - tu treba len pozbierat data z formulara
  getDataFormulara(strana?: number): ZaznamTextu[] {

    if (!this.typyZaznamuTextu) {
      this.spinner = false;
      return;
    }

    let zaznamyTextovNaOdoslaniePole: ZaznamTextu[] = [];
    // pozbierame data z formularovych poloziek
    const typyZaznamovTextu = strana ?
      this.getTypyZaznamovPodlaStrany(strana) : this.typyZaznamuTextu;

    //TODO: tu potrebujem doplnit logiku, aby sa do zoznamu "typyZaznamovTextu"
    // pridala aj polozka "datum poslednej modifikacie"


    for (const typZaznamu of typyZaznamovTextu) {

      // zbierame data len z POLOZIEK
      if (typZaznamu.idDruhZaznamuTextu !== this.POLOZKA) {
        continue;
      }

      const kodyJazykov: string[] = this.kodJazykRadioBox.split(', ');

      for (const kodJazyk of kodyJazykov) {

        let menoControlsu = 'name_' + typZaznamu.id + '_' + kodJazyk;

        // hladam, ci sa zaznam pre dany typ v DB uz nachadza
        let valueControlsu: string;

        // OPAKOVANE NESKUPINOVE POLOZKY + polozky podprogramu, kde TypZaznamuTextu.podprogram === 1 && this.idPodprogram > 0
        // pri stud. programoch povazujeme za opakovane aj tie polozky, ktore maju TypZaznamuTextu.podprogram > 0
        // (mozu sa totiz zobrazit viackrat, napr. raz za jeden podprogram, druhykrat za druhy podprogram)
        if (typZaznamu.opakovanie === 'A' &&
            (!typZaznamu.idSkupina || typZaznamu.idSkupina === 0)
            || (this.appStateService.jeOpakovaniePodprogramu(typZaznamu))) {

          const formArray = <UntypedFormArray>this.formularFormGroup.get(menoControlsu);
          // console.log('formArray: ' + formArray.get[0]);
          // console.log('formArray length: ' + formArray.length);
          for (let index = 0; index < formArray.length; index++) {
            const control = <UntypedFormControl>formArray.get(index.toString());
            // console.log('control ' + index + ': ' + control);
            // console.log('control ' + index + ': ' + control.value);
            valueControlsu = control ? control.value : null;

            // toString() kvoli datumu, lebo ten nevieme priamo "otrimovat";
            // V pripade, ze ide o spolocnu polozku podprogramu pre stud. program
            // chceme, aby sa dostala na server aj v pripade prazdnej polozky - tak ju vieme "vymazat".
            if ((valueControlsu != null && valueControlsu.toString().trim() !== '')
              || this.jeSpolocnaPolozkaPodprogramuPreStudProgram(typZaznamu.id, index+1, kodJazyk)) {

              // Kontrola pre textareu - potrebujeme osetrit, aby sa prazdna textarea s html tagmi nedostala do DB
              if (typZaznamu.idTypObjektu === this.TEXTAREA && valueControlsu) {
                let textBezHtmlTagov =
                  valueControlsu.replace(/<(?:.|\n)*?>/gm, '');
                if (!textBezHtmlTagov.trim()) {
                  continue;
                }
              }

              // console.log('valueControlsu: ' + typZaznamu.id + '_' + valueControlsu);
              let zaznamTextu: ZaznamTextu = new ZaznamTextu();

              zaznamTextu.idTypZaznamTextu = typZaznamu.id;
              zaznamTextu.kodJazyk = kodJazyk;
              zaznamTextu.idOsoba = this.idOsoby;
              zaznamTextu.idStudProgram = this.idStudProgram;
              zaznamTextu.idPodprogram = this.idPodprogram;
              zaznamTextu.poradie = index + 1;
              // pre podprogram pridavame oznacene stud. programy
              if (this.appStateService.jeOpakovaniePodprogramu(typZaznamu)) {

                if (this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov.get(typZaznamu.id)
                  && this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov.get(typZaznamu.id).get(kodJazyk)) {


                  // poradia poloziek z DB mame v mape "this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1",
                  // - potrebujeme ich premapovat podla indexov zobrazenych poloziek vo formulari
                  let poradie = index + 1;
                  const mapaIdTypovAMapJazykovAPoliPoradi
                    = this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1.get(typZaznamu.id);

                  if (mapaIdTypovAMapJazykovAPoliPoradi && mapaIdTypovAMapJazykovAPoliPoradi.get(kodJazyk)) {
                      const polePoradi = mapaIdTypovAMapJazykovAPoliPoradi.get(kodJazyk);
                      // vyberieme a odstranime prvy prvok z pola
                      // poradie = polePoradi.shift();
                      if (polePoradi[index]) {
                        poradie = polePoradi[index];
                      }
                   }

                  zaznamTextu.studijneProgramy
                    = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
                        .get(typZaznamu.id).get(zaznamTextu.kodJazyk).get(poradie);

                }

                if (this.appStateService.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.get(typZaznamu.id)) {
                  const zaznamy = this.appStateService.mapaIdTypovAMapJazykovAZaznamovsPodprogramami
                                                  .get(typZaznamu.id).get(kodJazyk);
                  if (zaznamy && zaznamy.length > index) {
                    zaznamTextu.idPodprogramSpolocnaPolozka = zaznamy[index].idPodprogramSpolocnaPolozka;
                    // console.log('ID SPOLOCNA POLOZKA: ' + zaznamTextu.idPodprogramSpolocnaPolozka);
                  }
                }

              }

              if (typZaznamu.idTypObjektu === this.DATE && valueControlsu) {
                const dateEN = this.datePipe.transform(valueControlsu, 'yyyy-MM-dd');
                zaznamTextu.text = dateEN;
                zaznamTextu.textString = dateEN;
              } else {
                zaznamTextu.text = valueControlsu;
                zaznamTextu.textString = valueControlsu;
              }

              // TODO: vazba na stupen a typ studia
              if (typZaznamu.vazba === this.VAZBA_STUPEN_TYP_STUDIA) {
                this.doplnitVazbuNaStupneATypyStudia(zaznamTextu, null, zaznamTextu.poradie);
              }


              zaznamyTextovNaOdoslaniePole.push(zaznamTextu);
            }

          }

        } else if (typZaznamu.idSkupina && typZaznamu.idSkupina !== 0) {

          // SKUPINOVE OPAKOVANIE

          menoControlsu = 'name_' + typZaznamu.idSkupina + '_' + kodJazyk;

          const formArray = <UntypedFormArray>this.formularFormGroup.get(menoControlsu);
          // console.log('formArray: ' + formArray.get[0]);
          // console.log('formArray length: ' + formArray.length);

          //TODO: tu by sme asi chceli cyklus
          if (kodJazyk === this.jazyk1) {
            let poradie = 0;
            for (const pozicia of this.mapaIdTypovAPoziciiVCastiSkupiny.get(typZaznamu.id)) {
              poradie++;
              // for (let index = 0; index < formArray.length; index++) {
              const control = <UntypedFormControl>formArray.get((pozicia-1).toString());
              // console.log('control ' + poradie + ': ' + control);
              // console.log('control ' + index + ': ' + control.value);
              valueControlsu = control ? control.value : null;

              // toString() kvoli datumu, lebo ten nevieme priamo "otrimovat"
              if (valueControlsu != null && valueControlsu.toString().trim() !== '') {

                // Kontrola pre textareu - potrebujeme osetrit, aby sa prazdna textarea s html tagmi nedostala do DB
                if (typZaznamu.idTypObjektu === this.TEXTAREA) {
                  let textBezHtmlTagov =
                    valueControlsu.replace(/<(?:.|\n)*?>/gm, '');
                  if (!textBezHtmlTagov.trim()) {
                    continue;
                  }
                }

                // console.log('valueControlsu: ' + typZaznamu.id + '_' + valueControlsu);
                let zaznamTextu: ZaznamTextu = new ZaznamTextu();

                zaznamTextu.idTypZaznamTextu = typZaznamu.id;
                zaznamTextu.kodJazyk = kodJazyk;
                zaznamTextu.idOsoba = this.idOsoby;
                zaznamTextu.idStudProgram = this.idStudProgram;
                zaznamTextu.idPodprogram = this.idPodprogram;
                zaznamTextu.poradie = poradie;
                if (typZaznamu.idTypObjektu === this.DATE) {
                  const dateEN = this.datePipe.transform(valueControlsu, 'yyyy-MM-dd');
                  zaznamTextu.text = dateEN;
                  zaznamTextu.textString = dateEN;
                } else {
                  zaznamTextu.text = valueControlsu;
                  zaznamTextu.textString = valueControlsu;
                }

                // TODO: vazba na stupen a typ studia
                if (typZaznamu.vazba === this.VAZBA_STUPEN_TYP_STUDIA) {
                  this.doplnitVazbuNaStupneATypyStudia(zaznamTextu, typZaznamu.idSkupina,
                    poradie);
                }

                zaznamyTextovNaOdoslaniePole.push(zaznamTextu);
              }

            }
          }

          if (kodJazyk === this.jazyk2) {
            let poradie = 0;
            for (const pozicia of this.mapaIdTypovAPoziciiVCastiSkupinyJazyk2.get(typZaznamu.id)) {
              poradie++;
            // for (let index = 0; index < formArray.length; index++) {
              const control = <UntypedFormControl>formArray.get((pozicia-1).toString());
              // console.log('control ' + poradie + ': ' + control);
              // console.log('control ' + index + ': ' + control.value);
              valueControlsu = control ? control.value : null;

              // toString() kvoli datumu, lebo ten nevieme priamo "otrimovat"
            if (valueControlsu != null && valueControlsu.toString().trim() !== '') {

              // Kontrola pre textareu - potrebujeme osetrit, aby sa prazdna textarea s html tagmi nedostala do DB
                if (typZaznamu.idTypObjektu === this.TEXTAREA) {
                  let textBezHtmlTagov =
                    valueControlsu.replace(/<(?:.|\n)*?>/gm, '');
                  if (!textBezHtmlTagov.trim()) {
                    continue;
                  }
                }

                // console.log('valueControlsu: ' + typZaznamu.id + '_' + valueControlsu);
                let zaznamTextu: ZaznamTextu = new ZaznamTextu();

                zaznamTextu.idTypZaznamTextu = typZaznamu.id;
                zaznamTextu.kodJazyk = kodJazyk;
                zaznamTextu.idOsoba = this.idOsoby;
                zaznamTextu.idStudProgram = this.idStudProgram;
                zaznamTextu.idPodprogram = this.idPodprogram;
                zaznamTextu.poradie = poradie;
                if (typZaznamu.idTypObjektu === this.DATE) {
                  const dateEN = this.datePipe.transform(valueControlsu, 'yyyy-MM-dd');
                  zaznamTextu.text = dateEN;
                  zaznamTextu.textString = dateEN;
                } else {
                  zaznamTextu.text = valueControlsu;
                  zaznamTextu.textString = valueControlsu;
                }

                // TODO: vazba na stupen a typ studia
                if (typZaznamu.vazba === this.VAZBA_STUPEN_TYP_STUDIA) {
                  this.doplnitVazbuNaStupneATypyStudia(zaznamTextu, typZaznamu.idSkupina,
                    poradie);
                }

                zaznamyTextovNaOdoslaniePole.push(zaznamTextu);
              }

            }
          }

          // vetva pre jazyk 3
          if (kodJazyk === this.jazyk3) {
            let poradie = 0;
            for (const pozicia of this.mapaIdTypovAPoziciiVCastiSkupinyJazyk3.get(typZaznamu.id)) {
              poradie++;
            // for (let index = 0; index < formArray.length; index++) {
              const control = <UntypedFormControl>formArray.get((pozicia-1).toString());
              // console.log('control ' + poradie + ': ' + control);
              // console.log('control ' + index + ': ' + control.value);
              valueControlsu = control ? control.value : null;

              // toString() kvoli datumu, lebo ten nevieme priamo "otrimovat"
            if (valueControlsu != null && valueControlsu.toString().trim() !== '') {

              // Kontrola pre textareu - potrebujeme osetrit, aby sa prazdna textarea s html tagmi nedostala do DB
                if (typZaznamu.idTypObjektu === this.TEXTAREA) {
                  let textBezHtmlTagov =
                    valueControlsu.replace(/<(?:.|\n)*?>/gm, '');
                  if (!textBezHtmlTagov.trim()) {
                    continue;
                  }
                }

                // console.log('valueControlsu: ' + typZaznamu.id + '_' + valueControlsu);
                let zaznamTextu: ZaznamTextu = new ZaznamTextu();

                zaznamTextu.idTypZaznamTextu = typZaznamu.id;
                zaznamTextu.kodJazyk = kodJazyk;
                zaznamTextu.idOsoba = this.idOsoby;
                zaznamTextu.idStudProgram = this.idStudProgram;
                zaznamTextu.idPodprogram = this.idPodprogram;
                zaznamTextu.poradie = poradie;
                if (typZaznamu.idTypObjektu === this.DATE) {
                  const dateEN = this.datePipe.transform(valueControlsu, 'yyyy-MM-dd');
                  zaznamTextu.text = dateEN;
                  zaznamTextu.textString = dateEN;
                } else {
                  zaznamTextu.text = valueControlsu;
                  zaznamTextu.textString = valueControlsu;
                }

                // TODO: vazba na stupen a typ studia
                if (typZaznamu.vazba === this.VAZBA_STUPEN_TYP_STUDIA) {
                  this.doplnitVazbuNaStupneATypyStudia(zaznamTextu, typZaznamu.idSkupina,
                    poradie);
                }

                zaznamyTextovNaOdoslaniePole.push(zaznamTextu);
              }

            }
          }

        }

        else {

          // NEOPAKOVANE POLOZKY
          valueControlsu = this.formularFormGroup.get(menoControlsu).value;

          // toString() kvoli datumu, lebo ten nevieme priamo "otrimovat"
          if (valueControlsu != null && valueControlsu.toString().trim() !== '') {
            // console.log('valueControlsu: ' + typZaznamu.id + '_' + valueControlsu);

            // Kontrola pre textareu - potrebujeme osetrit, aby sa prazdna textarea s html tagmi nedostala do DB
            if (typZaznamu.idTypObjektu === this.TEXTAREA) {
              let textBezHtmlTagov =
                valueControlsu.replace(/<(?:.|\n)*?>/gm, '');
              if (!textBezHtmlTagov.trim()) {
                continue;
              }
            }

            let zaznamTextu: ZaznamTextu = new ZaznamTextu();

            zaznamTextu.idTypZaznamTextu = typZaznamu.id;
            zaznamTextu.kodJazyk = kodJazyk;
            zaznamTextu.idOsoba = this.idOsoby;
            zaznamTextu.idStudProgram = this.idStudProgram;
            zaznamTextu.idPodprogram = this.idPodprogram;
            if (typZaznamu.idTypObjektu === this.DATE) {
              const dateEN = this.datePipe.transform(valueControlsu, 'yyyy-MM-dd');
              zaznamTextu.text = dateEN;
              zaznamTextu.textString = dateEN;
            } else {
              zaznamTextu.text = valueControlsu;
              zaznamTextu.textString = valueControlsu;
            }

            // TODO: vazba na stupen a typ studia
            if (typZaznamu.vazba === this.VAZBA_STUPEN_TYP_STUDIA) {
              zaznamTextu.stupneStudia = this.appStateService.mapaIdTypovZaznamuAStupnovStudia.get(typZaznamu.id);
              zaznamTextu.typyStudia = this.appStateService.mapaIdTypovZaznamuATypovStudia.get(typZaznamu.id);
            }

            zaznamyTextovNaOdoslaniePole.push(zaznamTextu);
          }

        }

      }

    }

    return zaznamyTextovNaOdoslaniePole;

  }

  zobrazOKDialog(text: string, title?: string) {
    // this.dialogDetailZobrazeny = true;
    const dialogConfig = new MatDialogConfig();
    if (title) {
      const dialogTitle = this.translateService.instant(title);
      dialogConfig.width = '500px';
      dialogConfig.data = {
        message: text,
        title: dialogTitle
      };
    } else {
      dialogConfig.data = {
        message: text
      };
    }
    // dialogConfig.width = '400px';

    const dialogRef = this.dialog.open(OkDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(() => {
      // this.dialogDetailZobrazeny = false;
      console.log('The dialog was closed');
    });

  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
    if (this.zaznamyTextovDataSavedSubscription) {
      this.zaznamyTextovDataSavedSubscription.unsubscribe();
    }
    this.zaznamyTextovDataSubscription.unsubscribe();
    this.aktualnaStranaSubscription.unsubscribe();
    if (this.pocetPripustnychSPPodprogramuSubscription) {
      this.pocetPripustnychSPPodprogramuSubscription.unsubscribe();
    }
    if (this.infoOExistenciiDokumentovSubscription) {
      this.infoOExistenciiDokumentovSubscription.unsubscribe();
    }
  }

  vyplnFormular() {
    this.formularFormGroup.patchValue(this.zaznamyTextuZDBIdTypAText);
    // let control = <FormControl>(<FormArray>this.formularFormGroup.get('name_470_SK')).get('2');


    this.nastavitSpecifickeVlastnostiPoloziekFormulara();

  }

  setVisibleDataByLanguage(jazyk: string) {
    if (!this.typyZaznamuTextu) {
      return;
    }
    // console.log('Zmena z radioboxu prisla na rodica :) ' + jazyk);
    this.kodJazykRadioBox = jazyk;
    this.appStateService.vybranyJazykFormulara = jazyk;
    // console.log('kodJazykRadioBox.includes(EN) : ' + this.kodJazykRadioBox.includes('EN'));


    //TODO: kontrola na zmenu osobnych udajov
    // spms 122354 - pre dokumenty VUPCH a VTC nahradzame osobne udaje z LZOsoba, ak nie su rovnake s tymi vo formulari.
    if (this.idTypDokumentuTextu === this.TYP_DOKUMENTU_VUPCH
      || this.idTypDokumentuTextu === this.TYP_DOKUMENTU_VTC) {

        // v pripade, ze je vybrana kombinacia jazykov, potrebujeme to vyriesit
        for (let kodJazyk of jazyk.split(',')) {
          this.skontrolujAUpravVyplnenieOsobnychUdajovPreJazyk(kodJazyk.trim(), this.zaznamyTextuZDBIdTypAText);

        }

        // spms 122354 - pre dokumenty VUPCH a VTC nahradzame osobne udaje z LZOsoba, ak nie su rovnake.
        /*
          Ak sa na formulari zmenili osobne udaje (prepisali sa datami z osoby),
          pouzivatela o tom oboznamime, nech sa mu nemenia data pod rukami
          bez toho, aby o tom vedel.
          Informacia bude zobrazena pre kazdy jazyk zvlast.
        */
        this.getUpozornenieNaZmenuOsobnychUdajov();

    }


  }


  getTypyZaznamovPodlaStrany(strana: number) {
    let result: TypZaznamuTextu[] = [];
    result = this.typyZaznamuTextu
      .filter((typ: TypZaznamuTextu) => {
        return typ.strana === strana;
      });


    return result;

  }

  generujDokument(generovatProgramyPodprogramu: boolean, kontrolovatStavDokumentu: boolean = true,
    requestParametre?: RequestZKlienta) {

    // console.log('Generuj dokument');

    const vybraneJazykyFormularaPole = this.kodJazykRadioBox.split(', ');

    let textNovaVerzia = '';
    if (vybraneJazykyFormularaPole.length > 1 || generovatProgramyPodprogramu) {
      textNovaVerzia = this.translateService.instant('Chcete dokumenty uložiť ako novú verziu?');
    } else  {
      textNovaVerzia = this.translateService.instant('Chcete dokument uložiť ako novú verziu?');
    }

    if (!generovatProgramyPodprogramu) {
      this.appStateService.kontrolaDokumentovVZakazanomStave();
    }

    // TODO: treba vyriesit vsetky tieto pripady
    // 1. vsetky dokumenty su v koncovom stave
    // 2. niektore dokumentu su v koncovom stave
    // 3. vsetky dokumenty su OK

    // TODO: tu vyriesime koncove stavy (teda tie, pri ktorych sa da pokracovat - vytvorit nova verzia dokumentov)
    if (kontrolovatStavDokumentu
        && this.appStateService.niektoryZDokumentovVJazykuJeVKoncovomStave(vybraneJazykyFormularaPole)) {

      let poleJazykovZHlasky: string[];
      let text = '';

      if (vybraneJazykyFormularaPole.length === 1) {
        // ak som vo formulari vybral prave 1 jazyk
        const jazyk = vybraneJazykyFormularaPole[0];
        const stavUzavretaVerzia = this.appStateService.mapaUzavretychStavovDokumentovPreIchJazyky.get(jazyk);
        if (stavUzavretaVerzia) {
          text = this.translateService.instant('Dokument v') + ' ' + jazyk + ' '
            + this.translateService.instant('jazyku') +  this.translateService.instant('je v uzavretej verzii') + ' '
            + '(' + stavUzavretaVerzia.stavPopis + '), '
            + this.translateService.instant('preto ho nie je možné aktualizovať') + '.'
            + this.translateService.instant('Chcete vytvoriť novú verziu tohto dokumentu?');

          poleJazykovZHlasky = [jazyk];
        }


      } else {
        // ak si vyberiem vo formulari kombinaciu jazykov

        // ak je len jeden dokument v koncovom (uzavretom) stave
        if (this.appStateService.mapaUzavretychStavovDokumentovPreIchJazyky.size === 1) {
          // tato konstrukcia vrati prvy kluc z mapy
          const [jazyk] = this.appStateService.mapaUzavretychStavovDokumentovPreIchJazyky.keys();
          text = this.translateService.instant('Dokument v') + ' '
            + jazyk + ' ' + this.translateService.instant('jazyku') + ' '
            + this.translateService.instant('je v uzavretej verzii') + ', '
            + this.translateService.instant('preto ho nie je možné aktualizovať') + '. '
            + this.translateService.instant('Chcete vytvoriť novú verziu tohto dokumentu?');

          poleJazykovZHlasky = [jazyk];

        } else {
          // ak je viac ako 1 dokument v koncovom (uzavretom) stave
          const jazyky = Array.from(this.appStateService.mapaUzavretychStavovDokumentovPreIchJazyky.keys());
          text = this.translateService.instant('Dokumenty v jazykoch') + ' '
            + jazyky.join(', ') + ' ' + this.translateService.instant('sú v uzavretej verzii') + ', '
            + this.translateService.instant('preto ich nie je možné aktualizovať') + '. '
            + this.translateService.instant('Chcete vytvoriť novú verziu týchto dokumentov?');

            poleJazykovZHlasky = jazyky;

        }

      }


      if (text) {

        const dialogRef
          = this.appStateService.openConfirmDialog(text);

        dialogRef.afterClosed().subscribe((result: string) => {

          // TODO: dialog pre potvrdenie vytvorenia novej verzie pri existencii dokumentu
          // this.infoOExistenciiDokumentovSubscription
          //   = this.appStateService.infoOExistenciiDokumentovDataFetched
          //     .subscribe(data => {
          //       if (this.idPodprogram && this.idPodprogram > -1) {
          //         this.poleJazykovDokumentovPodprogramuaStudProgramovExistujucichDokumentov = data;
          //       } else {
          //         this.poleJazykovExistujucichDokumentovPreOsobuAStudProgram = data;
          //       }
          //     });



          if ('OK' === result) {

            this.zistiSposobUlozeniaAGenerujDokument(generovatProgramyPodprogramu,
              textNovaVerzia + '', requestParametre);

          } else {

            // const poleJazykovUzavretychStavov
            //   = Array.from(this.appStateService.mapaUzavretychStavovDokumentovPreIchJazyky.keys());
            this.appStateService.poleJazykovUzavretychStavovKdePouzivatelNechceNovuVerziu = poleJazykovZHlasky;

            /* toto je vetva pre stav, ak pouzivatel zada pri otazke "nie"
            (nechce vytvorit novu verziu), ale my potrebujeme pregenerovat este
            dokument v inom jazyku */
            // riesime to iba v pripade, ak mam vybranu kombinaciu jazykov - v pripade jedneho jazyka vsetko zastavime a vybavene
            if (vybraneJazykyFormularaPole.length === this.data.jazykyFormulara.length) {
              // treba nejaky parameter, aby sme servru dali vediet, ze pre tento dokument nechceme novu verziu
              const jazykKdeNechcemNovuVerziu= poleJazykovZHlasky;
              if (!requestParametre) {
                requestParametre = new RequestZKlienta();
              }
              requestParametre.jazykyKdePouzivatelNechceVytvoritNovyVariant = jazykKdeNechcemNovuVerziu;
              // potrebujem stav uzavreta verzia, dajme teda napr. 6
              // const idStavUzavretaVerzia = 6;
              this.zistiSposobUlozeniaAGenerujDokument(generovatProgramyPodprogramu,
                textNovaVerzia, requestParametre);

            } else {
              this.ulozFormularAOdosliDataNaServer(false, false, true);
            }

          }
        });

      } else {
        // dokumenty su v OK stave
        this.zistiSposobUlozeniaAGenerujDokument(generovatProgramyPodprogramu,
          textNovaVerzia, requestParametre);
      }

    } else {

      // dokumenty su v OK stave alebo ich nechceme kontrolovat
      this.zistiSposobUlozeniaAGenerujDokument(generovatProgramyPodprogramu,
        textNovaVerzia, requestParametre);

    }

  }

  /** metoda zisti, ci chce pouzivatel existujuci dokument prepisat */
  zistiSposobUlozeniaAGenerujDokument(generovatProgramyPodprogramu: boolean,
    textNovaVerzia: string, requestParametre: RequestZKlienta) {

    // stiahneme si info o tom, ci uz existuju dokumenty
    if (this.infoOExistenciiDokumentovSubscription) {
      this.infoOExistenciiDokumentovSubscription.unsubscribe();
    }
    this.appStateService.fetchInfoOExistenciiDokumentov();


    // generovanie dokumentu musi prebehnut az po zisteni, ci chce pouzivatel novu verziu
    this.infoOExistenciiDokumentovSubscription
      = this.appStateService.infoOExistenciiDokumentovDataFetched
        .subscribe(data => {

          /* ak mi pride zo servra v "data" dvojrozmerne pole (resp. ak this.idPodprogram > 0),
          * viem, ze je to podprogram s pripustnymi stud. programami, kde data[0] su jazyky podprogramu,
          * v ktorych uz existuje v systeme dokument,
          * a data[1] su stud. programy, pre ktore existuje dokument v jazykoch,
          * ktore si pouzivatel zvolil na formulari v radioboxe jazykov
          */
          if (data.length > 0) {


            if (this.idPodprogram && this.idPodprogram > 0) {

              let podprogramJazyky: string[] = data[0];
              let studProgramyPodprogramu: string[] = data[1];

              const jazykyDokumentovVKoncovychStavoch: string[]
                = Array.from(this.appStateService.mapaUzavretychStavovDokumentovPreIchJazyky.keys());
              const jazykyDokumentovVZakazanychStavoch: string[]
                = Array.from(this.appStateService.mapaZakazanychStavovDokumentovPreIchJazyky.keys());

              // zaujimaju nas len jazyky editovatelnych stavov
              podprogramJazyky = podprogramJazyky
                  .filter(jazyk => !jazykyDokumentovVKoncovychStavoch.includes(jazyk))
                  .filter(jazyk => !jazykyDokumentovVZakazanychStavoch.includes(jazyk))


              // rozbijeme dvojrozmerne pole stud. programov na jednotlive polia a spojime ich do jedneho jednorozmerneho
              let studProgramyPodprogramuDokumentovVKoncovychStavoch: string[] = [];
              if (this.appStateService.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.size > 0) {
                studProgramyPodprogramuDokumentovVKoncovychStavoch
                  = Array.from(this.appStateService.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.values())
                    .reduce((a,b) => {
                      return a.concat(b);
                    });
              }

              let studProgramyPodprogramuDokumentovVZakazanychStavoch: string[] = [];
              if (this.appStateService.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.size > 0) {
                studProgramyPodprogramuDokumentovVZakazanychStavoch
                  = Array.from(this.appStateService.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.values())
                    .reduce((a, b) => {
                      return a.concat(b);
                    });
              }

              studProgramyPodprogramu
                = studProgramyPodprogramu
                  .filter(studProgram => !studProgramyPodprogramuDokumentovVKoncovychStavoch.includes(studProgram))
                  .filter(studProgram => !studProgramyPodprogramuDokumentovVZakazanychStavoch.includes(studProgram))


              if (podprogramJazyky && podprogramJazyky.length > 0
                && studProgramyPodprogramu && studProgramyPodprogramu.length > 0) {

                  textNovaVerzia = this.translateService.instant('Dokument pre podprogram v jazyku') + ' '
                    + podprogramJazyky.join(', ') + ' '
                    + this.translateService.instant('a') + ' '
                    + this.translateService.instant('dokumenty štud. programov') + ' '
                    + studProgramyPodprogramu.join(', ') + ' '
                    + this.translateService.instant('už v systéme existujú') + '. ' + textNovaVerzia;
              } else if (!studProgramyPodprogramu || studProgramyPodprogramu.length === 0) {
                textNovaVerzia = this.translateService.instant('Dokument pre podprogram v jazyku') + ' '
                  + podprogramJazyky.join(', ') + ' '
                  + this.translateService.instant('už v systéme existuje') + '. ' + textNovaVerzia;
              } else {
                // ak existuju dokumenty pre stud. programy, ale nie pre podprogram
                textNovaVerzia = this.translateService.instant('Dokumenty pre štud. programy') + ' '
                  + studProgramyPodprogramu.join(', ') + ' '
                  + this.translateService.instant('už v systéme existujú') + '. ' + textNovaVerzia;
              }

            } else {
              // this.poleJazykovExistujucichDokumentovPreOsobuAStudProgram = data;
              const poleJazykovExistujucichDokumentovPreOsobuAStudProgram: string[] = data;

              const poleJazykovDokumentovVKoncovychStavoch: string[]
                = Array.from(this.appStateService.mapaUzavretychStavovDokumentovPreIchJazyky.keys());

              const poleJazykovDokumentovVZakazanychStavoch: string[]
                = Array.from(this.appStateService.mapaZakazanychStavovDokumentovPreIchJazyky.keys());

              const poleJazykovExistujucichDokumentovPreOsobuAStudProgramVEditovatelnomStave
                = poleJazykovExistujucichDokumentovPreOsobuAStudProgram
                  .filter(jazyk => !poleJazykovDokumentovVKoncovychStavoch.includes(jazyk))
                  .filter(jazyk => !poleJazykovDokumentovVZakazanychStavoch.includes(jazyk))

              // editovatelny stav = nie koncovy a "zakazany"
              if (poleJazykovExistujucichDokumentovPreOsobuAStudProgramVEditovatelnomStave.length > 0) {
                textNovaVerzia = this.translateService.instant('Dokument v jazyku') + ' '
                  + poleJazykovExistujucichDokumentovPreOsobuAStudProgramVEditovatelnomStave.join(', ') + ' '
                  + this.translateService.instant('už v systéme existuje') + '. ' + textNovaVerzia;
              } else { // ziadny z dokumentov nie je v "normalnom" stave (bud su vsetky koncove alebo zakazane)
                textNovaVerzia = null;
              }

            }

            if (textNovaVerzia) {
              const dialogRef
                = this.appStateService.openConfirmDialog(textNovaVerzia);

              dialogRef.afterClosed().subscribe((result: string) => {

                if (result === 'OK') {
                  if (requestParametre) {
                    requestParametre.chcemGenerovatNovuVerziuDokumentov = true;
                  }
                } else {
                  if (!requestParametre) {
                    requestParametre = new RequestZKlienta();
                  }
                  requestParametre.chcemGenerovatNovuVerziuDokumentov = false;
                }

                textNovaVerzia = '';

                // dokumenty su v OK stave alebo ich nechceme kontrolovat
                this.generovanieDokumentu(generovatProgramyPodprogramu, requestParametre);

              });
            } else { // ziadny z dokumentov nie je v "normalnom" stave (bud su vsetky koncove alebo zakazane)
              this.generovanieDokumentu(generovatProgramyPodprogramu, requestParametre);
            }

          } else {
            // dokumenty su v OK stave alebo ich nechceme kontrolovat
              this.generovanieDokumentu(generovatProgramyPodprogramu, requestParametre);
          }


       });


  }


  generujDokumentStudProgramom() {

    // console.log('Generuj dokument stud. programom');

    // TODO: toto urobit obdobne ako s metodou nizsie
    // kontrola dokumentov podprogramu, stud. programu a osoby (!pozor - nie stud. programov podprogramu - ta pride neskor!)
    if (!this.appStateService.kontrolaDokumentovVZakazanomStave()) {
      return;
    }
    // tato globalna premenna ma pre stud. programy podprogramu hodnotu "false"
    // tato globalna premenna zafunguje pre osobu, stud. program, aj podprogram (ale nie stud. programy podprogramu - na to je speci premenna)
    const vybraneJazykyFormularaPole = this.kodJazykRadioBox.split(', ');
    if (this.appStateService.niektoryZDokumentovVJazykuJeVKoncovomStave(vybraneJazykyFormularaPole)) {

      const jazyky = Array.from(this.appStateService.mapaUzavretychStavovDokumentovPreIchJazyky.keys());
      const text = this.translateService.instant('Dokument pre podprogram v jazyku')+ ' '
      + jazyky.join(', ') + ' '
      + this.translateService.instant('je v uzavretej verzii') + ', '
      + this.translateService.instant('preto ho nie je možné aktualizovať') + '.'
      +  this.translateService.instant('Chcete vytvoriť novú verziu tohto dokumentu v danom jazyku?');

      const dialogRef
        = this.appStateService.openConfirmDialog(text);

      dialogRef.afterClosed().subscribe((result: string) => {
        if ('OK' === result) {
          this.kontrolaStavovAGenerovanieDokumentovPreSPPodprogramu();
        } else {
          const requestZKlienta = new RequestZKlienta();
          requestZKlienta.jazykyKdePouzivatelNechceVytvoritNovyVariant = jazyky;
          this.kontrolaStavovAGenerovanieDokumentovPreSPPodprogramu(requestZKlienta);
        }
      });

    } else {
      // dokument je vyhovujuci a nie je ani v koncovom stave (cize je editovatelny)
      this.kontrolaStavovAGenerovanieDokumentovPreSPPodprogramu();
    }

    // console.log('haha: ' + this.appStateService.dokumentJeVoVyhovujucomStave());

  }

  generovatDokumentSP(requestParametre: RequestZKlienta) {
    if (this.pocetPripustnychSPPodprogramuSubscription) {
      this.pocetPripustnychSPPodprogramuSubscription.unsubscribe();
    }

    this.appStateService.fetchPocetPripustnychProgramovPodprogramuData();
    this.pocetPripustnychSPPodprogramuSubscription = this.appStateService.pocetPripustnychProgramovPodprogramuDataFetched
      .subscribe(pocetProgramov => {

        // console.log('POcet programov: ' + pocetProgramov);

        if (pocetProgramov > 50) {

          const text = this.translateService.instant('Tento podprogram má') + ' ' + pocetProgramov  + ' '
            + this.translateService.instant('prípustných študijných programov') + ', '
            + this.translateService.instant('preto môže generovanie trvať aj niekoľko minút') + '.'
            + this.translateService.instant('Pokračovať?');

          const dialogRef
            = this.appStateService.openConfirmDialog(text);

            dialogRef.afterClosed().subscribe((result: string) => {
              if ('OK' === result) {
                // console.log('DOBRE NO!');
                this.generujDokument(true, false,
                  requestParametre);
              }
            });

        } else {
          this.generujDokument(true, false,
            requestParametre);
        }

      });

  }

  getTooltipPreNavigacnyButton() {
    let output = '';
    if (this.disablovatNavigacneButtonyKvoliZadaniuStrany) {
      output = this.translateService.instant('Strana') + ' ' + this.zvolenaStrana;
    } else {
      const strana = this.aktualnaStrana + 1;
      output = this.translateService.instant('Strana') + ' ' + strana;
    }

    return output;
  }

  posunNaStranu(strana: number, posunutNaZaciatokFormulara: boolean) {
    if (strana < 1 || strana > this.pocetStran) {
      return;
    }
    this.typyZaznamovNaStranu =
      this.typyZaznamuTextu
        .filter((typ) => {
          return typ.strana === strana;
        });

    this.ulozFormularAOdosliDataNaServer(false, false,true);
    // if (!posunutNaZaciatokFormulara) {
    //   window.scrollTo(0,document.body.scrollHeight);
    // }

    this.aktualnaStrana = strana;
    this.disablovatNavigacneButtonyKvoliZadaniuStrany = false;
    // console.log('Aktualna strana: ' + this.aktualnaStrana);
    if (this.aktualnaStrana === this.pocetStran) {
      this.disablujPotvrdzovaciButton = true;
    }

    // TODO: ak budem vediet ako, doplnim aj posunutie na koniec formulara
    // if (posunutNaZaciatokFormulara) {
      this.scroller.scrollToAnchor('zacFormularTarget');
    // } else {
    //   console.log('posuvam sa na koniec stranky');
    //   // this.scroller.scrollToAnchor('koniecFormularaTarget');
    // }

  }

  vlavo(strana: number) {
    this.posunNaStranu(strana - 1, false);
  }

  vpravo(strana: number) {
    this.posunNaStranu(strana + 1, true);
  }

  prvaStrana() {
    this.posunNaStranu(1, false);
  }

  poslednaStrana() {
    this.posunNaStranu(this.pocetStran, false);
  }

  saveStranaInput(event) {
    // console.log('saveStranaInput - event target: ' + event.target);
    const strana = Number(event.target.value);
    if (!isNaN(strana) && strana > 0 && strana <= this.pocetStran) {
      this.posunNaStranu(strana, false);
    }
  }

  openErrorDialog(msg: string) {
    this.dialog.open(ErrorDialogComponent, {
      panelClass: 'alert-danger',
        data: {message: msg},
        width: '500px',
      });
  }

  // jazykNaExplicitnePridanieOpakovania - parameter, ktory sa pouzije v pripade, ze chceme
  // explicitne pridat opakovanie pre dany jazyk (napr. pri pridavani opakovania v skupine v jazyku1)
  // a je potrebne, aby sa implicitne pridali ostatne jazyky, ktore nemam aktualne zobrazene vo formulari
  pridatSkupinoveOpakovanie(idSkupina: number, maxPocet: number,
    jazyk: string, pridatDoFormulara: boolean,
    opakovSkupinoveTypy: TypZaznamuTextu[],
    jazykNaExplicitnePridanieOpakovania?: any) {



    // spms 122901 - vyplnenie profilovych predmetov
    // jazykNaExplicitnePridanieOpakovania
    jazyk = jazykNaExplicitnePridanieOpakovania && typeof jazykNaExplicitnePridanieOpakovania === 'string'
      ? jazykNaExplicitnePridanieOpakovania : jazyk;

    console.log('pridatSkupinoveOpakovanie() - ' + this.pocetSkupinovychOpakovaniTEST++
      + ' - idSkupina: ' + idSkupina + ', jazyk: ' + jazyk
    );

    const text = this.translateService.instant('Už je pridaný maximálny povolený počet položiek.');
    if (jazyk === this.jazyk1) {
      const pocetSkupinovychOpakovaniJazyk1 = this.mapaIdSkupinAPoctovOpakovani.get(idSkupina);
      if (pocetSkupinovychOpakovaniJazyk1 >= maxPocet) {
        this.openErrorDialog(text);
        return;
      }
    } else if (jazyk === this.jazyk2) {
      const pocetSkupinovychOpakovaniJazyk2 = this.mapaIdSkupinAPoctovOpakovaniJazyk2.get(idSkupina);
      if (pocetSkupinovychOpakovaniJazyk2 >= maxPocet) {
        this.openErrorDialog(text);
        return;
      }
    } else if (jazyk === this.jazyk3) {
      const pocetSkupinovychOpakovaniJazyk3 = this.mapaIdSkupinAPoctovOpakovaniJazyk3.get(idSkupina);
      if (pocetSkupinovychOpakovaniJazyk3 >= maxPocet) {
        this.openErrorDialog(text);
        return;
      }
    }


    let opakovaneSkupinoveTypy =
      opakovSkupinoveTypy ? opakovSkupinoveTypy : [];

    if (!opakovSkupinoveTypy || opakovSkupinoveTypy.length === 0) {
      let mapaIdciekSkupinATypov: Map<number, TypZaznamuTextu[]> = new Map();

      for (const typ of this.typyZaznamovNaStranu) {
        if (typ.idSkupina && typ.idDruhZaznamuTextu === this.POLOZKA) {
          if (!mapaIdciekSkupinATypov.get(typ.idSkupina)) {
            mapaIdciekSkupinATypov.set(typ.idSkupina, [typ]);
          } else {
            mapaIdciekSkupinATypov.get(typ.idSkupina).push(typ);
          }
        }
      }

      for (const typ of mapaIdciekSkupinATypov.get(idSkupina)) {
        opakovaneSkupinoveTypy.push(typ);
      }

    }



    if (opakovaneSkupinoveTypy.length > 0) {

      const pocetTypovVSkupine = this.mapaIdJednoznacnychTypovVSkupine.get(idSkupina).length;
      let pocetOpakovanychCastiVSkupine = 0;
      switch (jazyk) {

        case this.jazyk1:
          pocetOpakovanychCastiVSkupine = this.mapaIdSkupinAPoctovOpakovani.get(idSkupina);
          this.mapaIdSkupinAPoctovOpakovani.set(idSkupina,
            pocetOpakovanychCastiVSkupine
              + (opakovaneSkupinoveTypy.length / pocetTypovVSkupine));
          break;

        case this.jazyk2:
          pocetOpakovanychCastiVSkupine = this.mapaIdSkupinAPoctovOpakovaniJazyk2.get(idSkupina);
          this.mapaIdSkupinAPoctovOpakovaniJazyk2.set(idSkupina,
            pocetOpakovanychCastiVSkupine
              + (opakovaneSkupinoveTypy.length / pocetTypovVSkupine));
          break;

        case this.jazyk3:
          pocetOpakovanychCastiVSkupine = this.mapaIdSkupinAPoctovOpakovaniJazyk3.get(idSkupina);
          this.mapaIdSkupinAPoctovOpakovaniJazyk3.set(idSkupina,
            pocetOpakovanychCastiVSkupine
              + (opakovaneSkupinoveTypy.length / pocetTypovVSkupine));
          break;

          default:
          break;
      }

      const controlName = 'name_' + idSkupina + '_' + jazyk;
      let index = 0;
      for (const typ of opakovaneSkupinoveTypy) {
        index++;
        if (pridatDoFormulara) {
          let predvyplnenyText = typ.textPredvoleny;
          if (jazyk === this.jazyk2) {
            predvyplnenyText = typ.textPredvolenyJazyk2;
          } else if (jazyk === this.jazyk3) {
            predvyplnenyText = typ.textPredvolenyJazyk3;
          }
          const control = new FormControl({value: predvyplnenyText,
            disabled: typ.uroven === 2 && !this.appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty});
          (<FormArray>this.formularFormGroup.get(controlName)).push(control);
        }

        if (jazyk === this.jazyk1) {
          let mapaCastiATypovZaznamov = this.mapaIdSkupinAMapCastiATypovZaznamov.get(typ.idSkupina);
          // ak ide o nove opakovanie casti skupiny, pridame cast skupiny do mapy
          if (index % pocetTypovVSkupine === 1) {
            mapaCastiATypovZaznamov.set(mapaCastiATypovZaznamov.size + 1, [typ]);
          } else {
            mapaCastiATypovZaznamov.get(mapaCastiATypovZaznamov.size).push(typ);
          }
        } else if (jazyk === this.jazyk2) {
          let mapaCastiATypovZaznamov = this.mapaIdSkupinAMapCastiATypovZaznamovJazyk2.get(typ.idSkupina);
          // ak ide o nove opakovanie casti skupiny, pridame cast skupiny do mapy
          if (index % pocetTypovVSkupine === 1) {
            mapaCastiATypovZaznamov.set(mapaCastiATypovZaznamov.size + 1, [typ]);
          } else {
            mapaCastiATypovZaznamov.get(mapaCastiATypovZaznamov.size).push(typ);
          }

        } else if (jazyk === this.jazyk3) {
          let mapaCastiATypovZaznamov = this.mapaIdSkupinAMapCastiATypovZaznamovJazyk3.get(typ.idSkupina);
          // ak ide o nove opakovanie casti skupiny, pridame cast skupiny do mapy
          if (index % pocetTypovVSkupine === 1) {
            mapaCastiATypovZaznamov.set(mapaCastiATypovZaznamov.size + 1, [typ]);
          } else {
            mapaCastiATypovZaznamov.get(mapaCastiATypovZaznamov.size).push(typ);
          }

        }

        // verzia pre jazyk 1
        const poradiaPole = this.mapaIdTypovAPoziciiVCastiSkupiny.get(typ.id);
        const maxPoradiePreTyp = Math.max(...poradiaPole);
        this.mapaIdTypovAPoziciiVCastiSkupiny.get(typ.id).push(
          maxPoradiePreTyp + pocetTypovVSkupine);

        // verzia pre jazyk 2
        let poradiaPoleJazyk2 = [];
        if (this.existujeJazyk2) {
          poradiaPoleJazyk2 = this.mapaIdTypovAPoziciiVCastiSkupinyJazyk2.get(typ.id);
          const maxPoradiePreTypJazyk2 = Math.max(...poradiaPoleJazyk2);
          this.mapaIdTypovAPoziciiVCastiSkupinyJazyk2.get(typ.id).push(
            maxPoradiePreTypJazyk2 + pocetTypovVSkupine);
        }

        // verzia pre jazyk 3
        if (this.existujeJazyk3) {
          const poradiaPoleJazyk3 = this.mapaIdTypovAPoziciiVCastiSkupinyJazyk3.get(typ.id);
          const maxPoradiePreTypJazyk3 = Math.max(...poradiaPoleJazyk3);
          this.mapaIdTypovAPoziciiVCastiSkupinyJazyk3.get(typ.id).push(
            maxPoradiePreTypJazyk3 + pocetTypovVSkupine);
        }

      }


      if (jazyk === this.jazyk1) {
        // tuto mapu (this.mapaIdSkupinACastiSkupin) potrebujeme kvoli iteracii cez jednotlive casti skupiny pri skupinovom opakovani
        const pocetOpakovanychCastiVSkupine = this.mapaIdSkupinAPoctovOpakovani.get(idSkupina);
        let poleIdciekCastiSkupin = this.mapaIdSkupinACastiSkupin.get(idSkupina);
        while (poleIdciekCastiSkupin.length < pocetOpakovanychCastiVSkupine) {
          if (!poleIdciekCastiSkupin.includes(pocetOpakovanychCastiVSkupine)) {
            poleIdciekCastiSkupin.push(poleIdciekCastiSkupin.length + 1);
          } else {
            break;
          }
        }
      } else if (jazyk === this.jazyk2) {
        const pocetOpakovanychCastiVSkupine = this.mapaIdSkupinAPoctovOpakovaniJazyk2.get(idSkupina);
        let poleIdciekCastiSkupinJazyk2 = this.mapaIdSkupinACastiSkupinJazyk2.get(idSkupina);
        while (poleIdciekCastiSkupinJazyk2.length < pocetOpakovanychCastiVSkupine) {
          if (!poleIdciekCastiSkupinJazyk2.includes(pocetOpakovanychCastiVSkupine)) {
            poleIdciekCastiSkupinJazyk2.push(poleIdciekCastiSkupinJazyk2.length + 1);
          } else {
            break;
          }
        }
      } else if (jazyk === this.jazyk3) {
        const pocetOpakovanychCastiVSkupine = this.mapaIdSkupinAPoctovOpakovaniJazyk3.get(idSkupina);
        let poleIdciekCastiSkupinJazyk3 = this.mapaIdSkupinACastiSkupinJazyk3.get(idSkupina);
        while (poleIdciekCastiSkupinJazyk3.length < pocetOpakovanychCastiVSkupine) {
          if (!poleIdciekCastiSkupinJazyk3.includes(pocetOpakovanychCastiVSkupine)) {
            poleIdciekCastiSkupinJazyk3.push(poleIdciekCastiSkupinJazyk3.length + 1);
          } else {
            break;
          }
        }
      }



    }

    // console.log(this.formularFormGroup);

  }

  // POCET OPAKOVANI V SKUPINE (default je ("minPocet" * pocet poloziek v casti skupiny))
  // pocet poloziek, ktore sa realne budu vyplnat (hoci len prazdnymi datami)
  getPocetSkupinovychOpakovaniVoFormulari(idSkupina: number,
      mapaIdciekSkupinATypov: Map<number, number[]>,
      zaznamySkupinoveZDB: ZaznamTextu[]): number {

    // zistime max. poradie vsetkych zaznamov v skupine
    let maxRealnePoradieVSkupine = 0;
    for (const z of zaznamySkupinoveZDB) {
      if (z.poradie > maxRealnePoradieVSkupine) {
        maxRealnePoradieVSkupine = z.poradie;
      }
    }

    // potrebujeme zistit, kolko casti skupin mame k dispozicii (predpokladame na vstupe zoradene pole zaznamov podla poradia)
    let poradieZoZaznamu = zaznamySkupinoveZDB[0].poradie;
    let pocetCastiSkupin = 1;
    for (const z of zaznamySkupinoveZDB) {
      if (z.poradie !== poradieZoZaznamu) {
        poradieZoZaznamu = z.poradie;
        pocetCastiSkupin++;
      }
    }

    const pocetTypovVCastiSkupiny = mapaIdciekSkupinATypov.get(idSkupina).length;
    // ake poradie bude mat maximalne policko casti skupiny, v ktorej je vyplnena aspon jedna polozka
    // TODO:
    // const pocetCastiSkupin = maxRealnePoradieVSkupine;
    // const pocetCastiSkupin = Math.floor((maxRealnePoradieVSkupine - 1) / pocetTypovVCastiSkupiny) + 1;
    return pocetCastiSkupin * pocetTypovVCastiSkupiny;

  }

  // potrebujeme doplnit do formulara skupinove polozky (!aj prazdne!)
  getSkupinoveZaznamyTextuDoFormulara(idSkupina: number,
    pocetVsetkychPoloziekVSkupine: number,
    mapaIdciekSkupinATypov: Map<number, number[]>,
    zaznamySkupinoveZDB: ZaznamTextu[]): ZaznamTextu[] {

    // potrebujeme doplnit do formulara polozky (!aj prazdne!)
    let zaznamyTextuDoFormulara: ZaznamTextu[] = [];
    const idckaTypovVSkupine = mapaIdciekSkupinATypov.get(idSkupina);

    let mapaIdciekTypovAZaznamovTextovZDB: Map<number, ZaznamTextu[]> = new Map();

    // 1. vytvorim mapu, kde bude ako kluc idTyp a value pole zaznamov z DB, ktore su daneho typu;
    // 2. postupne budeme vyplnat formular podla poradia

    // const poleZaznamov = [...zaznamySkupinoveZDB];
    let poradiaZaznamovJednoznacne: number[] = [];
    for (const z of zaznamySkupinoveZDB) {
      if (!mapaIdciekTypovAZaznamovTextovZDB.has(z.idTypZaznamTextu)) {
        mapaIdciekTypovAZaznamovTextovZDB.set(z.idTypZaznamTextu, [z]);
      } else {
        mapaIdciekTypovAZaznamovTextovZDB.get(z.idTypZaznamTextu).push(z);
      }
      if (!poradiaZaznamovJednoznacne.includes(z.poradie)) {
        poradiaZaznamovJednoznacne.push(z.poradie);
      }
    }
    // uloha 122212: potrebujeme do pola poradi doplnit vsetky poradia, ktore su mensie ako maximalne,
    // aby sa vo formulari brali do uvahy aj prazdne casti skupin
    const maximalnePoradie = Math.max(...poradiaZaznamovJednoznacne);
    for (let index = 1; index < maximalnePoradie; index++) {
      if (!poradiaZaznamovJednoznacne.includes(index)) {
        poradiaZaznamovJednoznacne.push(index);
      }
    }
    poradiaZaznamovJednoznacne.sort((a, b) => a - b);

    for (const poradie of poradiaZaznamovJednoznacne) {

      // let poradieZaznamu = 0;
      for (const idTyp of idckaTypovVSkupine) {

        let zaznamyTextovPreTypPole = mapaIdciekTypovAZaznamovTextovZDB.get(idTyp);
        // poradieZaznamu = zazna
        let zaznamNajdeny = false;
        if (zaznamyTextovPreTypPole) {
          for (const z of zaznamyTextovPreTypPole) {
            // TODO:
            // if (idTyp === z.idTypZaznamTextu && z.poradie === castSkupiny) {
              if (z.poradie === poradie) {
                zaznamyTextuDoFormulara.push(z);
                zaznamNajdeny = true;
                break;
              }
          }
        }

        // doplnenie prazdnych poloziek
        if (!zaznamNajdeny) {
          let zt = new ZaznamTextu();
          zt.text = '';
          zt.idTypZaznamTextu = idTyp;
          zaznamyTextuDoFormulara.push(zt);
          continue;
        }

      }

    }

    return zaznamyTextuDoFormulara;
  }


  pridatHodnotuDoFormulara(value: string, idTyp: number,
    indexPolozkyVoFormulari: number, jazyk: string) {

    const menoControlsu = 'name_' + idTyp + '_' + jazyk;

    let control = <UntypedFormControl>(<UntypedFormArray>this.formularFormGroup.get(menoControlsu))
      .get(indexPolozkyVoFormulari.toString());

    control.patchValue(value);

    // console.log('formControlValues: ' + this.formularFormGroup);

  }


  zobrazitPolozkuPodlaPlatnosti(typ: TypZaznamuTextu): boolean {

    //TODO:
    // this.vyrobMapu();

    // if (typ.id === -34) {
    //   const haha = '';
    // }

    //TODO:
    // if (!typ.polozkaJePlatna
    //     && !this.poleIdciekZaznamov.includes(typ.id)) {
    //   return false;
    // }

    // if (!typ.polozkaJePlatna) {
    //   return false;
    // }

    return typ.polozkaJePlatna;
    // return true;
  }

  // TODO: uvidime, ci to vobec vyuzijem
  vyrobMapu() {
    let map: Map<number, number[]> = new Map();

    // let idDruhZaznamuTextu = -1;
    for (let i = 0; i < this.typyZaznamuTextu.length; i++) {
      const typ = this.typyZaznamuTextu[i];
      let idDruhZaznamu = typ.idDruhZaznamuTextu;
      let posun = 0;
      map.set(typ.id, [typ.id]);
      posun++;


      if (typ.id === -12) {
        const haha = '';
      }

      if (typ.id === -107) {
        const haha = '';
      }

      for (let j = i + 1; j < this.typyZaznamuTextu.length; j++) {
        const typJ = this.typyZaznamuTextu[j];

        if (typJ.id === -12) {
          const haha = '';
        }


        // NIE POLOZKA
        // ak nejde o polozku a su to typy so stupajucim idDruhZaznamuTextu,
        // patria tie typy dokopy
        if (typJ.idDruhZaznamuTextu !== this.POLOZKA) {
          if (typJ.idDruhZaznamuTextu > idDruhZaznamu) {
            if (!map.has(typ.id)) {
              map.set(typ.id, [typJ.id]);
            } else {
              map.get(typ.id).push(typJ.id);
            }
            idDruhZaznamu = typ.idDruhZaznamuTextu;
            posun++;
            if (j + 1 === this.typyZaznamuTextu.length) {
              if (posun > 0) {
                i = i + posun;
              }
              break;
            } else {
              continue;
            }
          } else {
            if (posun > 0) {
              i = i + (posun - 1);
            }
            break;
          }
        } else {
          // POLOZKA

          if (typJ.idDruhZaznamuTextu >= idDruhZaznamu
            || ( typ.idSkupina !== 0 && typJ.idSkupina !== 0 && (typ.idSkupina === typJ.idSkupina))) {

            if (!map.has(typ.id)) {
              map.set(typ.id, [typJ.id]);
            } else {
              map.get(typ.id).push(typJ.id);
            }
            posun++;
            if (j + 1 === this.typyZaznamuTextu.length) {
              if (posun > 0) {
                i = i + posun;
              }
              break;
            } else {
              continue;
            }
            idDruhZaznamu = typJ.idDruhZaznamuTextu;
          } else {
            if (posun > 0) {
              i = i + (posun - 1);
            }
            break;
          }

        }

      }

    }

    const koneec = '';

  }


  getTextPredvoleny(typZaznamuTextu: TypZaznamuTextu, jazyk: string): string {

    let result = typZaznamuTextu.textPredvoleny;

    switch (jazyk) {

      case this.jazyk2:
        if (typZaznamuTextu.textPredvolenyJazyk2) {
          result = typZaznamuTextu.textPredvolenyJazyk2;
        }
        break;

      case this.jazyk3:
        if (typZaznamuTextu.textPredvolenyJazyk3) {
          result = typZaznamuTextu.textPredvolenyJazyk3;
        }
        break;

      default:
        break;

    }

    return result;

  }


  pridajPolozkuDoMapyVyplnenychPoloziek(idTyp: number, jazyk: string, poradie: number) {
    if (!this.appStateService.mapaIdTypovAMapJazykovAPoradiZaznamov.get(idTyp)) {
      const mapa: Map<string, number[]> = new Map();
      mapa.set(jazyk, [poradie]);
      this.appStateService.mapaIdTypovAMapJazykovAPoradiZaznamov.set(idTyp, mapa);
    } else {
      const mapa = this.appStateService.mapaIdTypovAMapJazykovAPoradiZaznamov.get(idTyp);
      if (!mapa.get(jazyk)) {
        mapa.set(jazyk, [poradie]);
      } else {
        mapa.get(jazyk).push(poradie);
      }
    }
  }

  jeSpolocnaPolozkaPodprogramuPreStudProgram(idTyp: number, poradie: number, kodJazyk: string): boolean {

    if (this.idStudProgram > 0) {
      const mapa = this.appStateService.mapaIdTypovAMapJazykovAPoradiZaznamov.get(idTyp);
      if (mapa && mapa.get(kodJazyk)
        && mapa.get(kodJazyk).includes(poradie)) {

          return true;
        }
    }
    return false;
  }

  naplnMapuIdTypovAMapJazykovAPoliPoradiZaznamovPodprogramu(z: ZaznamTextu) {

    if (!this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1.get(z.idTypZaznamTextu)) {

      const mapa: Map<string, number[]> = new Map();
      mapa.set(z.kodJazyk, [z.poradie]);
      this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1
        .set(z.idTypZaznamTextu, mapa);

    } else if (!this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1.get(z.idTypZaznamTextu).get(z.kodJazyk)) {

      const mapa = this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1.get(z.idTypZaznamTextu);
      mapa.set(z.kodJazyk, [z.poradie]);

    } else {

      const poradiaPole = this.appStateService.mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1
        .get(z.idTypZaznamTextu).get(z.kodJazyk);

      poradiaPole.push(z.poradie);

    }

  }

  naplnMapuIdTypovAMapJazykovAMapPoradiAPoliStudProgramovZaznamuPodprogramu(z: ZaznamTextu) {

    const mapaPoradiAStudProgramov: Map<number, StudijnyProgram[]> = new Map();

    // nastavime poradie (pre ktoru konkretnu polozku daneho typu a jazyka pridavame stud. programy)
    // let poradie = 1;
    // if (this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
    //     .get(z.idTypZaznamTextu)
    //   && this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
    //       .get(z.idTypZaznamTextu).get(z.kodJazyk)) {

    //   poradie = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
    //     .get(z.idTypZaznamTextu).get(z.kodJazyk).size + 1;
    // }
    // mapaPoradiAStudProgramov.set(poradie, z.studijneProgramy);

    // z.studijneProgramy moze nadobudat aj hodotu null - to bude znamenat, ze polozka nema vo formulari stud. programy vybrane a vlozime do mapy prazdne pole (nech tam nie je hodnota "undefined")
    mapaPoradiAStudProgramov.set(z.poradie, z.studijneProgramy ? z.studijneProgramy : []);

    const mapaJazykovAMapPoradiAStudProgramov: Map<string, Map<number, StudijnyProgram[]>>
      = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov.get(z.idTypZaznamTextu);

    if (!mapaJazykovAMapPoradiAStudProgramov) {
      const mapaJazykovAMapPoradiAStudProgramov: Map<string, Map<number, StudijnyProgram[]>> = new Map();
      mapaJazykovAMapPoradiAStudProgramov.set(z.kodJazyk, mapaPoradiAStudProgramov);
      this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
        .set(z.idTypZaznamTextu, mapaJazykovAMapPoradiAStudProgramov);

    } else if (!mapaJazykovAMapPoradiAStudProgramov.get(z.kodJazyk)) {
      const mapa
        = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov.get(z.idTypZaznamTextu);
      mapa.set(z.kodJazyk, mapaPoradiAStudProgramov);
    } else {
      const mapa = this.appStateService.mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov
        .get(z.idTypZaznamTextu).get(z.kodJazyk);

      mapa.set(z.poradie, z.studijneProgramy ? z.studijneProgramy : []);

    }


  }


  generovanieDokumentu(generovatProgramyPodprogramu: boolean,
    requestZKlientaParametre?: RequestZKlienta, idStavDokumentu?: number) {

        // 1. zozbierame data z formulara
    // 2. posleme data na server
    // 3. tam sa z dat vygeneruje xmlko a to sa nasledne prezenie html transformaciou
    // 4. dokument sa odosle naspat na klienta a zobrazi

    this.spinner = true;

    // 1.
    const zaznamyTextovNaOdoslaniePole = this.getDataFormulara();
    this.zaznamyTextovZDB = zaznamyTextovNaOdoslaniePole;
    this.appStateService.zaznamyTextovZDB = zaznamyTextovNaOdoslaniePole;

    // 2.
    if (this.kodJazykRadioBox === this.jazyk1 || this.kodJazykRadioBox === this.jazyk2 || this.kodJazykRadioBox === this.jazyk3) {
      this.appStateService.ulozFormularAGenerujDokument(zaznamyTextovNaOdoslaniePole,
        this.idTypDokumentuTextu, this.data.idDruhDokumentu, this.fakulta,
        this.idStudProgram, this.idPodprogram, this.idOsoby,
        this.kodJazykRadioBox, generovatProgramyPodprogramu,
        requestZKlientaParametre);
    } else {
      // ak som si vybral na formulari kombinaciu jazykov
      this.appStateService.ulozFormularAGenerujDokumentVJazykoch(zaznamyTextovNaOdoslaniePole,
        this.idTypDokumentuTextu, this.data.idDruhDokumentu,
        this.idStudProgram, this.idPodprogram, this.idOsoby, this.fakulta,
        generovatProgramyPodprogramu,
        requestZKlientaParametre);
    }

    // this.spinner = true;

  }

  kontrolaStavovAGenerovanieDokumentovPreSPPodprogramu(requestParametre?: RequestZKlienta) {

    // 1. najprv kontrola na NEEDITOVATELNE (zakazane) STAVY
    let requestKlient
        = this.appStateService.kontrolaNeeditovatelnychStavovDokumentovSPPodprogramuPreZvolenyJazyk(requestParametre);

    // 2. tu riesime UZAVRETE VERZIE, ktore mozu mat novu verziu (na servri sa to tusim vola "variant")
    const jazykyDokumentovSPPodprogramuVKoncovychStavoch
      = Array.from(this.appStateService.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.keys());
    const vybranyJazykFormulara = this.kodJazykRadioBox.split(', ');
    const prienikJazykovFormularaAKoncovychStavovDokumentovSPPodprogramu = jazykyDokumentovSPPodprogramuVKoncovychStavoch
      .filter(x => vybranyJazykFormulara.includes(x));
    const niektoreDokumentySPPodprogramuVJazykuSuVKoncovomStave
      = prienikJazykovFormularaAKoncovychStavovDokumentovSPPodprogramu.length > 0;

    if (niektoreDokumentySPPodprogramuVJazykuSuVKoncovomStave) {

      let studProgramyText = '';
      let i = 0;
      let studProgramyPole: string[] = [];
      for (const jazyk of prienikJazykovFormularaAKoncovychStavovDokumentovSPPodprogramu) {

        const studProgramyPole2 = this.appStateService.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.get(jazyk);
        if (studProgramyPole2) {
          studProgramyPole.push(...studProgramyPole2);
        }
      }

      if (studProgramyPole) {

        if (i >= 1 && i < prienikJazykovFormularaAKoncovychStavovDokumentovSPPodprogramu.length) {
          studProgramyText += ', ';
        }

        studProgramyText += studProgramyPole.join(', ');
        i++;

      }

      let textOtazky = '';

      if (prienikJazykovFormularaAKoncovychStavovDokumentovSPPodprogramu.length === 1) {
        const jazyk = prienikJazykovFormularaAKoncovychStavovDokumentovSPPodprogramu[0];
        if (studProgramyPole.length === 1 ) {
          textOtazky = 'Dokument v jazyku' + ' ' + jazyk + ' ' + 'pre štud. program' + ' ' + studProgramyText
            + ' ' + 'je v uzavretej verzii, preto ho nie je možné aktualizovať' + '. '
            + 'Chcete vytvoriť novú verziu tohto dokumentu?';
        } else if (studProgramyPole.length > 1) {
          textOtazky = 'Dokumenty v jazyku' + ' ' + jazyk + ' ' + 'pre štud. programy' + ' ' + studProgramyText
            + ' ' + 'sú v uzavretej verzii, preto ich nie je možné aktualizovať' + '. '
            + 'Chcete vytvoriť novú verziu týchto dokumentov?';
        }
      } else {
        textOtazky = 'Dokumenty pre štud. programy' + ' ' + studProgramyText
          + ' ' + 'sú v uzavretej verzii, preto ich nie je možné aktualizovať' + '. '
          + 'Chcete vytvoriť novú verziu týchto dokumentov?';
      }

      const dialogRef
        = this.appStateService.openConfirmDialog(textOtazky);

      dialogRef.afterClosed().subscribe((result: string) => {
          if ('OK' === result) {
            // console.log('DOBRE NO!');
            this.generovatDokumentSP(requestKlient);
          } else {
            //TODO: chceme pustit generovanie aj napriek nesuhlasu pouzivatela - kvoli ostatnym jazykom a stud. programom
            if (!requestKlient) {
              requestKlient = new RequestZKlienta();
            }
            if (!requestKlient.studijneProgramyStavPreJazyk) {
              requestKlient.studijneProgramyStavPreJazyk = [];
            }
            for (const jazyk of prienikJazykovFormularaAKoncovychStavovDokumentovSPPodprogramu) {
              const studijneProgramyStavPreJazyk = new StudijneProgramyStavPreJazyk();
              studijneProgramyStavPreJazyk.jazyk = jazyk;
              studijneProgramyStavPreJazyk.studProgramyStavUzavretaVerziaKdeNechcemNovuVerziuVariant
                = this.appStateService.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.get(jazyk);
              requestKlient.studijneProgramyStavPreJazyk.push(studijneProgramyStavPreJazyk);
            }


            this.generovatDokumentSP(requestKlient);
          }
      });

    } else {
      this.generovatDokumentSP(requestKlient);
    }

  }

  vsetkyTypyVSkupineSuUrovne2(idSkupina: number, skupinaCislo: number, kodJazyk: string): boolean {

    let pocet = 0;
    if (kodJazyk === this.jazyk1) {
      for (const typ of this.mapaIdSkupinAMapCastiATypovZaznamov.get(idSkupina).get(skupinaCislo)) {
        if (typ.uroven === 2) {
          pocet++;
        }
      }
    } else if (kodJazyk === this.jazyk2) {
      for (const typ of this.mapaIdSkupinAMapCastiATypovZaznamovJazyk2.get(idSkupina).get(skupinaCislo)) {
        if (typ.uroven === 2) {
          pocet++;
        }
      }
    } else {
      for (const typ of this.mapaIdSkupinAMapCastiATypovZaznamovJazyk3.get(idSkupina).get(skupinaCislo)) {
        if (typ.uroven === 2) {
          pocet++;
        }
      }
    }

    const pocetTypovVSkupine = this.mapaIdJednoznacnychTypovVSkupine.get(idSkupina).length;
    if (pocet === pocetTypovVSkupine) {
      return true;
    }

    return false;
  }


  openStudijneProgramyPodprogramyDialog() {

    let dialogRef = null;

    if (this.idStudProgram && this.idStudProgram > 0) {

      dialogRef = this.dialog.open(
        StudijneProgramyCopyingDialogComponent, {
          data: {
            idStudProgram: this.idStudProgram,
            pocetSkopirovanychPoloziek: this.pocetSkopirovanychPoloziek,
          },
          width: '480px'
        });

    } else if (this.idPodprogram && this.idPodprogram > 0) {

      dialogRef = this.dialog.open(
        PodprogramyCopyingDialogComponent, {
          data: {
            podprogram: this.idPodprogram,
            pocetSkopirovanychPoloziek: this.pocetSkopirovanychPoloziek,
          },
          width: '480px'
        });

    }

    if (dialogRef) {
      dialogRef.afterClosed().subscribe(result => {
        if (!result && result !== 0) {
          return;
        }
        this.spinner = true;
      });
    }

  }

  vymazatFormular() {

    const dialogRef = this.appStateService.openConfirmDialog(
      this.translateService.instant('Naozaj chcete vymazať a uložiť všetky vyplnené položky formulára, t.j. vyčistiť formulárový dokument?'));

    dialogRef.afterClosed().subscribe((result: string) => {
      if ('OK' === result) {
        this.vymazatAUlozitFormular();
      }
    });

  }

  vymazatAUlozitFormular() {
    this.formularFormGroup.reset();
    this.ulozFormularAOdosliDataNaServer(true, false, false);
    this.appStateService.openOKDialog(this.translateService.instant('Formulár bol vymazaný a uložený.'));
  }

  zobrazDialogSPoctomSkopirovanychPoloziek(pocet: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message: this.translateService.instant("Počet skopírovaných položiek formulára") + ': ' + pocet
    };
    // dialogConfig.width = '400px';

    this.spinner = false;
    const dialogRef = this.dialog.open(OkDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(() => {
      // refreshneme celu aplikaciu, aby sa zobrazili aktualne data po skopirovani
      if (pocet > 0) {
        window.location.reload();
      }

    });

  }

  // inspiracia v nadpis-blok-sekcia-druh.component.ts - riadok 66
  presunSkupinovePolozky(typ: TypZaznamuTextu, index: number, kodJazyk: string) {

    const name =  'name_'+ typ.idSkupina + '_' + kodJazyk;

    // let textPolozky1 = this.formularFormGroup.get(name).value;
    // console.log('Text polozky na kopirovanie: ' + textPolozky1);

    const formArray = <UntypedFormArray>this.formularFormGroup.get(name);
    const polePovodnychHodnot: [] = formArray.value;

    //skopirovanie povodneho pola hodnot
    const poleNovychHodnot: string[] = [...polePovodnychHodnot];

    const pocetPoloziekVCastiSkupiny = this.mapaPoctovZaznamovPreSkupinu.get(typ.idSkupina);
    const indexPrvejPolozkyVCastiSkupiny = index * pocetPoloziekVCastiSkupiny;
    const indexPoslednejPolozkyVCastiSkupiny = indexPrvejPolozkyVCastiSkupiny + pocetPoloziekVCastiSkupiny - 1;
    for (let i = indexPrvejPolozkyVCastiSkupiny; i <= indexPoslednejPolozkyVCastiSkupiny; i++) {
      poleNovychHodnot[i] = polePovodnychHodnot[i-pocetPoloziekVCastiSkupiny];
      poleNovychHodnot[i-pocetPoloziekVCastiSkupiny] = polePovodnychHodnot[i];
    }

    formArray.patchValue(poleNovychHodnot);

    // alternativa k vyssiemu
    // this.formularFormGroup.patchValue({[name] : poleNovychHodnot});

  }

  getKopirovaciButtonTooltip() {
    let result = '';
    if (this.idStudProgram && this.idStudProgram > 0) {
      result = this.translateService.instant("Vyplniť formulár dokumentom vybratého študijného programu");
    } else if (this.idPodprogram && this.idPodprogram > 0) {
      // result = this.translateService.instant("Vyplniť formulár dokumentom vybratého podprogramu");
      result = this.translateService.instant("Vyplniť formulár dokumentom vybratého podprogramu, časti študijného programu");
    }
    return result;
  }

  getVymazatFormularTooltip() {
    return this.translateService.instant("Vymazať formulár");
  }

  getPrvaStranaTooltip() {
    return this.translateService.instant("Prvá strana");
  }

  getPoslednaStranaTooltip() {
    return this.translateService.instant("Posledná strana");
  }

  getVlavoTooltip() {
    return this.translateService.instant('Strana') + ' ' + (this.aktualnaStrana - 1);
  }

  getVymenitSkupinyPoloziekTooltip() {
    return this.translateService.instant('Vymeniť skupiny položiek');
  }

  getPridatPolozkyVSkupineTooltip(maxPocet: number) {
    return this.translateService.instant('Pridať položky v skupine') + ' ('
    + this.translateService.instant('maximálny počet je') + ' ' + maxPocet + ')';
  }

  doplnitVazbuNaStupneATypyStudia(zaznamTextu: ZaznamTextu, idSkupina: number,
    poradie: number) {

    // console.log('doplnitVazbuNaStupneATypyStudia()');

    if (idSkupina && idSkupina !== 0) {
      // SKUPINOVE OPAKOVANIE
      const mapaStupnovStudia = this.appStateService.mapaSkupinAMapCastiSkupinyAPoliStupnovStudia.get(idSkupina);
      if (mapaStupnovStudia) {
        zaznamTextu.stupneStudia = mapaStupnovStudia.get(poradie);
      }

      const mapaTypovStudia = this.appStateService.mapaSkupinAMapCastiSkupinyAPoliTypovStudia.get(idSkupina);
      if (mapaTypovStudia) {
        zaznamTextu.typyStudia = mapaTypovStudia.get(poradie);
      }
    } else {
      // NESKUPINOVE OPAKOVANIE
      const mapaPoradiAStupnovStudia = this.appStateService.mapaIdTypovZaznamuAMapPoradiAStupnovStudia.get(zaznamTextu.idTypZaznamTextu);
      if (mapaPoradiAStupnovStudia) {
        zaznamTextu.stupneStudia = mapaPoradiAStupnovStudia.get(poradie);
      }

      const mapaPoradiATypovStudia = this.appStateService.mapaIdTypovZaznamuAMapPoradiATypovStudia.get(zaznamTextu.idTypZaznamTextu);
      if (mapaPoradiATypovStudia) {
        zaznamTextu.typyStudia = mapaPoradiATypovStudia.get(poradie);
      }

    }

  }

  naplnitMapyPreStupneATypyStudia(z: ZaznamTextu) {

    const idTyp = z.idTypZaznamTextu;

    //1. AK IDE O SKUPINU
    if (this.mapaIdTypovAIchIdSkupin.has(idTyp)) {

      const idSkupina = this.mapaIdTypovAIchIdSkupin.get(idTyp);

      if (z.stupneStudia && z.stupneStudia.length > 0) {

        const mapaHlavna = this.appStateService.mapaSkupinAMapCastiSkupinyAPoliStupnovStudia;

        if (!mapaHlavna.get(idSkupina)) {

          const mapaCastiSkupinyAStupnov: Map<number, string[]> = new Map();
          mapaCastiSkupinyAStupnov.set(z.poradie, z.stupneStudia);
          mapaHlavna.set(idSkupina, mapaCastiSkupinyAStupnov);

        } else {

          const mapaCastiSkupinyAStupnov = mapaHlavna.get(idSkupina);
          mapaCastiSkupinyAStupnov.set(z.poradie, z.stupneStudia);

        }

      }

      if (z.typyStudia && z.typyStudia.length > 0) {

        const mapaHlavna = this.appStateService.mapaSkupinAMapCastiSkupinyAPoliTypovStudia;

        if (!mapaHlavna.get(idSkupina)) {

          const mapaCastiSkupinyATypovStudia: Map<number, string[]> = new Map();
          mapaCastiSkupinyATypovStudia.set(z.poradie, z.typyStudia);
          mapaHlavna.set(idSkupina, mapaCastiSkupinyATypovStudia);

        } else {

          const mapaCastiSkupinyATypovStudia = mapaHlavna.get(idSkupina);
          mapaCastiSkupinyATypovStudia.set(z.poradie, z.typyStudia);

        }

      }

    } else if (z.poradie) {

      // 2. AK IDE O OPAKOVANIE (NIE SKUPINU)

      if (z.stupneStudia && z.stupneStudia.length > 0) {

        const mapaHlavna = this.appStateService.mapaIdTypovZaznamuAMapPoradiAStupnovStudia;

        if (!mapaHlavna.get(idTyp)) {

          const mapaPoradiAStupnovStudia: Map<number, string[]> = new Map();
          mapaPoradiAStupnovStudia.set(z.poradie, z.stupneStudia);
          mapaHlavna.set(idTyp, mapaPoradiAStupnovStudia);

        } else {

          const mapaPoradiAStupnovStudia = mapaHlavna.get(idTyp);
          mapaPoradiAStupnovStudia.set(z.poradie, z.stupneStudia);

        }

      }

      if (z.typyStudia && z.typyStudia.length > 0) {

        const mapaHlavna = this.appStateService.mapaIdTypovZaznamuAMapPoradiATypovStudia;

        if (!mapaHlavna.get(idTyp)) {

          const mapaPoradiATypovStudia: Map<number, string[]> = new Map();
          mapaPoradiATypovStudia.set(z.poradie, z.typyStudia);
          mapaHlavna.set(idTyp, mapaPoradiATypovStudia);

        } else {

          const mapaPoradiATypovStudia = mapaHlavna.get(idTyp);
          mapaPoradiATypovStudia.set(z.poradie, z.typyStudia);

        }

        // console.log('mapa "doplnitVazbuNaStupneATypyStudia" naplnena: '
        //   + this.appStateService.mapaIdTypovZaznamuAMapPoradiATypovStudia.get(idTyp).get(z.poradie));

      }

    } else {

      // 3. AK IDE O STANDARDNE NEOPAKOVANE A NESKUPINOVE POLOZKY

      if (z.stupneStudia && z.stupneStudia.length > 0) {

        const mapaHlavna = this.appStateService.mapaIdTypovZaznamuAStupnovStudia;

        if (!mapaHlavna.get(z.idTypZaznamTextu)) {
          mapaHlavna.set(z.idTypZaznamTextu, z.stupneStudia);
        }

      }

      if (z.typyStudia) {

        const mapaHlavna = this.appStateService.mapaIdTypovZaznamuATypovStudia;

        if (!mapaHlavna.get(z.idTypZaznamTextu)) {
          mapaHlavna.set(z.idTypZaznamTextu, z.typyStudia);
        }

      }


    }



  }

  naplnPotrebneMapy() {

    let i = 0;
    this.typyZaznamuTextu.forEach(typ => {
      if (typ.idSkupina && typ.idSkupina !== 0) {
        i++;
        this.mapaIdTypovAIchIdSkupin.set(typ.id, typ.idSkupina);
        // console.log("SERUS " + i);
      }
    });

    // console.log('this.mapaIdTypovAIchIdSkupin: ' + JSON.stringify(this.mapaIdTypovAIchIdSkupin));



    //
    this.mapaJazykovAMapIdSkupinACastiSkupin.set(this.jazyk1,
      this.mapaIdSkupinACastiSkupin
    );

    if (this.jazyk2) {
      this.mapaJazykovAMapIdSkupinACastiSkupin.set(this.jazyk2,
        this.mapaIdSkupinACastiSkupinJazyk2);

      if (this.jazyk3) {
        this.mapaJazykovAMapIdSkupinACastiSkupin.set(this.jazyk3,
          this.mapaIdSkupinACastiSkupinJazyk3
        );
      }

    }

  }


  // metoda vracia true, ak niektory zo zaznamov (ZaznamTextu)
  // je naviazany na stupne alebo typy studia (SCSTTypZaznamuTextu.variant = 1)
  niektoraZMapPreVariant1JeNaplnena() : boolean {

    if (this.appStateService.mapaIdTypovZaznamuAStupnovStudia.size > 0
      || this.appStateService.mapaIdTypovZaznamuATypovStudia.size > 0
      || this.appStateService.mapaIdTypovZaznamuAMapPoradiAStupnovStudia.size > 0
      || this.appStateService.mapaIdTypovZaznamuAMapPoradiATypovStudia.size > 0
      || this.appStateService.mapaSkupinAMapCastiSkupinyAPoliStupnovStudia.size > 0
      || this.appStateService.mapaSkupinAMapCastiSkupinyAPoliTypovStudia.size > 0
    ) {
      return true;
    }

    return false;

  }

  polozkaJeVCiselniku(text: string, typ: TypZaznamuTextu, kodJazyk: string) {

    switch (kodJazyk) {

      case this.jazyk1:
        return typ.polozkyCiselnika.includes(text);

      case this.jazyk2:
        return typ.polozkyCiselnikaJazyk2.includes(text);

      case this.jazyk3:
        return typ.polozkyCiselnikaJazyk3.includes(text);

      default:
        break;
    }

    return true;
  }

  somPolozkaVnutriSkupiny(typ: TypZaznamuTextu) {
    //podmienka, ktora overi, ci som polozka vnutri skupiny (mimo prvej polozky, ktora tu skupinu tvori)
    if (typ.idSkupina && typ.idSkupina !== 0 && typ.idSkupina !== typ.id) {
      return true;
    }

    return false;
  }

  getUpozornenieNaZmenuOsobnychUdajov() {

    if (this.zobrazenaInformaciaOZmeneOsobnychUdajovPreJazykMapa.get(this.kodJazykRadioBox)) {
      return;
    }

    if (this.zmeneneOsobneUdajePreJazykMapa.size > 0) {

      // v pripade, ze je vybrana kombinacia jazykov, potrebujeme to vyriesit
      let poleZmemnychOsobnychUdajov = [];
      for (let kodJazyk of this.kodJazykRadioBox.split(', ')) {
        if (this.zmeneneOsobneUdajePreJazykMapa.get(kodJazyk)) {
          for (let osobnyUdajNazov of this.zmeneneOsobneUdajePreJazykMapa.get(kodJazyk)) {
            if (!poleZmemnychOsobnychUdajov.includes(osobnyUdajNazov)) {
              poleZmemnychOsobnychUdajov.push(osobnyUdajNazov);
            }
          }
        }
      }

      const text = this.translateService.instant('Osobné údaje boli zmenené') + ' (' + poleZmemnychOsobnychUdajov.join(', ') + '). '
        + this.translateService.instant('Pri prechode na inú stranu dokumentu, pri priebežnom uložení a pri generovaní dokumentu bude formulár uložený s týmito novými osobnými údajmi.');

      this.zobrazOKDialog(text, 'Upozornenie');

      this.zobrazenaInformaciaOZmeneOsobnychUdajovPreJazykMapa.set(this.kodJazykRadioBox, true);

    }

  }


  skontrolujAUpravVyplnenieOsobnychUdajovPreJazyk(jazyk: string, formularJson) {

    this.zmeneneOsobneUdajePreJazykMapa.clear();

    let idPrePriezviskoPodlaTypuDokumentu = null;
    let idPreMenoPodlaTypuDokumentu = null;
    let idPreTitulyPodlaTypuDokumentu = null;
    let idPreRokNarodeniaPodlaTypuDokumentu = null;

    if (this.idTypDokumentuTextu === this.TYP_DOKUMENTU_VUPCH) {
      idPrePriezviskoPodlaTypuDokumentu = -2;
      idPreMenoPodlaTypuDokumentu = -3;
      idPreTitulyPodlaTypuDokumentu = -4;
      idPreRokNarodeniaPodlaTypuDokumentu = -5;
    } else if  (this.idTypDokumentuTextu === this.TYP_DOKUMENTU_VTC) {
      idPrePriezviskoPodlaTypuDokumentu = -152;
      idPreMenoPodlaTypuDokumentu = -153;
      idPreTitulyPodlaTypuDokumentu = -154;
    }

    // PRIEZVISKO
    if (this.data.osobaDokumentu.priezvisko && this.data.osobaDokumentu.priezvisko.length > 0) {

      const priezviskoString = this.translateService.instant('priezvisko');
      const namePriezvisko = 'name_' + idPrePriezviskoPodlaTypuDokumentu + '_' + jazyk;

      // ak uz vo formulari dana polozka existuje (existuje iba ak je vyplnena)
      if (namePriezvisko in formularJson) {

        //ak sa polozky z formulara a LZOsoba lisia, nahradime polozku vo formulari datami z LZOsoba
        if (formularJson[namePriezvisko].toUpperCase() !== this.data.osobaDokumentu.priezvisko.toUpperCase()) {

          this.zmenaVSledovanychPolozkachVJazykochMapa.set(jazyk, true);

          formularJson[namePriezvisko] = this.data.osobaDokumentu.priezvisko;
          this.formularFormGroup.get(namePriezvisko).setValue(this.data.osobaDokumentu.priezvisko);
          if (!this.zmeneneOsobneUdajePreJazykMapa.get(jazyk)) {
            this.zmeneneOsobneUdajePreJazykMapa.set(jazyk, [priezviskoString]);
          } else {
            this.zmeneneOsobneUdajePreJazykMapa.get(jazyk).push(priezviskoString);
          }
        }

      } else {
        // ak vo formulari dana polozka neexistuje, t.j. je nevyplnena
          formularJson[namePriezvisko] = this.data.osobaDokumentu.priezvisko;
          this.formularFormGroup.get(namePriezvisko).setValue(this.data.osobaDokumentu.priezvisko);
          if (!this.zmeneneOsobneUdajePreJazykMapa.get(jazyk)) {
            this.zmeneneOsobneUdajePreJazykMapa.set(jazyk, [priezviskoString]);
          } else {
            this.zmeneneOsobneUdajePreJazykMapa.get(jazyk).push(priezviskoString);
          }
          if (priezviskoString) {
            this.zmenaVSledovanychPolozkachVJazykochMapa.set(jazyk, true);
          }
      }

    }


    // MENO
    if (this.data.osobaDokumentu.meno && this.data.osobaDokumentu.meno.length > 0) {

        const menoString = this.translateService.instant('meno');
        const nameMeno = 'name_' + idPreMenoPodlaTypuDokumentu + '_' + jazyk;

      // ak uz vo formulari dana polozka existuje (existuje iba ak je vyplnena)
      if (nameMeno in formularJson) {

        //ak sa polozky z formulara a LZOsoba lisia, nahradime polozku vo formulari datami z LZOsoba
        if (formularJson[nameMeno].toUpperCase() !== this.data.osobaDokumentu.meno.toUpperCase()) {

          this.zmenaVSledovanychPolozkachVJazykochMapa.set(jazyk, true);

          formularJson[nameMeno] = this.data.osobaDokumentu.meno;
          this.formularFormGroup.get(nameMeno).setValue(this.data.osobaDokumentu.meno);
          if (!this.zmeneneOsobneUdajePreJazykMapa.get(jazyk)) {
            this.zmeneneOsobneUdajePreJazykMapa.set(jazyk, [menoString]);
          } else {
            this.zmeneneOsobneUdajePreJazykMapa.get(jazyk).push(menoString);
          }
        }

      } else {
        // ak vo formulari dana polozka neexistuje, t.j. je nevyplnena
          formularJson[nameMeno] = this.data.osobaDokumentu.meno;
          this.formularFormGroup.get(nameMeno).setValue(this.data.osobaDokumentu.meno);
          if (!this.zmeneneOsobneUdajePreJazykMapa.get(jazyk)) {
            this.zmeneneOsobneUdajePreJazykMapa.set(jazyk, [menoString]);
          } else {
            this.zmeneneOsobneUdajePreJazykMapa.get(jazyk).push(menoString);
          }

          if (menoString) {
            this.zmenaVSledovanychPolozkachVJazykochMapa.set(jazyk, true);
          }
      }

    }

    // TITULY
    if (this.data.osobaDokumentu.tituly && this.data.osobaDokumentu.tituly.length > 0) {

      const titulyString = this.translateService.instant('tituly');
      const nameTituly = 'name_' + idPreTitulyPodlaTypuDokumentu + '_' + jazyk;

      // ak uz vo formulari dana polozka existuje (existuje iba ak je vyplnena)
      if (nameTituly in formularJson) {

        //ak sa polozky z formulara a LZOsoba lisia, nahradime polozku vo formulari datami z LZOsoba
        if (formularJson[nameTituly].toUpperCase() !== this.data.osobaDokumentu.tituly.toUpperCase()) {

          this.zmenaVSledovanychPolozkachVJazykochMapa.set(jazyk, true);

          formularJson[nameTituly] = this.data.osobaDokumentu.tituly;
          this.formularFormGroup.get(nameTituly).setValue(this.data.osobaDokumentu.tituly);
          if (!this.zmeneneOsobneUdajePreJazykMapa.get(jazyk)) {
            this.zmeneneOsobneUdajePreJazykMapa.set(jazyk, [titulyString]);
          } else {
            this.zmeneneOsobneUdajePreJazykMapa.get(jazyk).push(titulyString);
          }
        }

      } else {
        // ak vo formulari dana polozka neexistuje, t.j. je nevyplnena
          formularJson[nameTituly] = this.data.osobaDokumentu.tituly;
          this.formularFormGroup.get(nameTituly).setValue(this.data.osobaDokumentu.tituly);
          if (!this.zmeneneOsobneUdajePreJazykMapa.get(jazyk)) {
            this.zmeneneOsobneUdajePreJazykMapa.set(jazyk, [titulyString]);
          } else {
            this.zmeneneOsobneUdajePreJazykMapa.get(jazyk).push(titulyString);
          }
          if (titulyString) {
            this.zmenaVSledovanychPolozkachVJazykochMapa.set(jazyk, true);
          }
      }

    }

    // ROK NARODENIA
    if (this.idTypDokumentuTextu === this.TYP_DOKUMENTU_VUPCH
      && this.data.osobaDokumentu.rokNarodenia
      && this.data.osobaDokumentu.rokNarodenia.length > 0) {

      const rokNarodeniaString = this.translateService.instant('rok narodenia');
      const nameRokNarodenia = 'name_' + idPreRokNarodeniaPodlaTypuDokumentu + '_' + jazyk;


      // ak uz vo formulari dana polozka existuje (existuje iba ak je vyplnena)
      if (nameRokNarodenia in formularJson) {

        //ak sa polozky z formulara a LZOsoba lisia, nahradime polozku vo formulari datami z LZOsoba
        if (formularJson[nameRokNarodenia].toUpperCase() !== this.data.osobaDokumentu.rokNarodenia.toUpperCase()) {

          this.zmenaVSledovanychPolozkachVJazykochMapa.set(jazyk, true);

          formularJson[nameRokNarodenia] = this.data.osobaDokumentu.rokNarodenia;
          this.formularFormGroup.get(nameRokNarodenia).setValue(this.data.osobaDokumentu.rokNarodenia);
          if (!this.zmeneneOsobneUdajePreJazykMapa.get(jazyk)) {
            this.zmeneneOsobneUdajePreJazykMapa.set(jazyk, [rokNarodeniaString]);
          } else {
            this.zmeneneOsobneUdajePreJazykMapa.get(jazyk).push(rokNarodeniaString);
          }
        }

      } else {
        // ak vo formulari dana polozka neexistuje, t.j. je nevyplnena
          formularJson[nameRokNarodenia] = this.data.osobaDokumentu.rokNarodenia;
          this.formularFormGroup.get(nameRokNarodenia).setValue(this.data.osobaDokumentu.rokNarodenia);
          if (!this.zmeneneOsobneUdajePreJazykMapa.get(jazyk)) {
            this.zmeneneOsobneUdajePreJazykMapa.set(jazyk, [rokNarodeniaString]);
          } else {
            this.zmeneneOsobneUdajePreJazykMapa.get(jazyk).push(rokNarodeniaString);
          }
          if (rokNarodeniaString) {
            this.zmenaVSledovanychPolozkachVJazykochMapa.set(jazyk, true);
          }
      }

    }





  }

  nastavitSpecifickeVlastnostiPoloziekFormulara() {

    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];

    // spms 122898 - celkovy pocet obhajenych prac (z AiS2 aj tie mimo AiS2)
    // potrebujeme spocitat do jedneho policka

    if (this.idTypDokumentuTextu === this.TYP_DOKUMENTU_VUPCH) {

      const ID_TYP_VUPCH_BAKALARSKE_ZAVERECNE_PRACE = -110;
      const ID_TYP_VUPCH_DIPLOMOVE_ZAVERECNE_PRACE = -114;
      const ID_TYP_VUPCH_DIZERTANE_ZAVERECNE_PRACE = -118;


      const zoznam = [ID_TYP_VUPCH_BAKALARSKE_ZAVERECNE_PRACE,
        ID_TYP_VUPCH_DIPLOMOVE_ZAVERECNE_PRACE,
        ID_TYP_VUPCH_DIZERTANE_ZAVERECNE_PRACE];

      for (const idTyp of zoznam) {

        const name = 'name_' + idTyp + '_' + this.jazyk1;
        const zaverecnePraceSkupinaFormArray = this.formularFormGroup.get(name) as UntypedFormArray;

        const control = zaverecnePraceSkupinaFormArray.controls[0];
        const control3 = zaverecnePraceSkupinaFormArray.controls[2];

        // hodnota z 1. inputu  "Evidovane v AiS2" by sa zrejme mala
        // predvyplnit aj do 3. inputu "V.4.a Bakalárske (prvý stupeň) - celkový počet"
        // (samozrejme to iste plati pre diplomove a dizertacne prace)"
        // - to plati ale iba v pripade, ze v DB uz 3. input nie je vyplneny (t.j. je prazdny),
        // lebo ak uz bol vyplneny, tak ho nechceme prepisat
        if (control.value && control3.value === '') {
          zaverecnePraceSkupinaFormArray?.controls[2]?.setValue(
            control.value,
            { emitEvent: false }
          );
        }

        this.subscriptions.push(
          control.valueChanges.subscribe(() => {
            this.prepocitajSucet(idTyp);
          })
        );

        const control2 = zaverecnePraceSkupinaFormArray.controls[1];
        this.subscriptions.push(
          control2.valueChanges.subscribe(() => {
            this.prepocitajSucet(idTyp);
          })
        );

        if (this.existujeJazyk2) {

          const nameJazyk2 = 'name_' + idTyp + '_' + this.jazyk2;
          const zaverecnePraceSkupinaJazyk2FormArray = this.formularFormGroup.get(nameJazyk2) as UntypedFormArray;

          const control = zaverecnePraceSkupinaJazyk2FormArray.controls[0];
          const control3 = zaverecnePraceSkupinaJazyk2FormArray.controls[2];
          // hodnota z 1. inputu  "Evidovane v AiS2" by sa zrejme mala
          // predvyplnit aj do 3. inputu "V.4.a Bakalárske (prvý stupeň) - celkový počet"
          // (samozrejme to iste plati pre diplomove a dizertacne prace)"
          // - to plati ale iba v pripade, ze v DB uz 3. input nie je vyplneny (t.j. je prazdny),
          // lebo ak uz bol vyplneny, tak ho nechceme prepisat
          if (control.value && control3.value === '') {
            zaverecnePraceSkupinaJazyk2FormArray?.controls[2]?.setValue(
              control.value,
              { emitEvent: false }
            );
          }

          this.subscriptions.push(
            control.valueChanges.subscribe(() => {
              this.prepocitajSucet(idTyp);
            })
          );

          const control2 = zaverecnePraceSkupinaJazyk2FormArray.controls[1];
          this.subscriptions.push(
            control2.valueChanges.subscribe(() => {
              this.prepocitajSucet(idTyp);
            })
          );

        }

        if (this.existujeJazyk3) {

          const nameJazyk3 = 'name_' + idTyp + '_' + this.jazyk3;
          const zaverecnePraceSkupinaJazyk3FormArray = this.formularFormGroup.get(nameJazyk3) as UntypedFormArray;

          const control = zaverecnePraceSkupinaJazyk3FormArray.controls[0];
          const control3 = zaverecnePraceSkupinaJazyk3FormArray.controls[2];

          // hodnota z 1. inputu  "Evidovane v AiS2" by sa zrejme mala
          // predvyplnit aj do 3. inputu "V.4.a Bakalárske (prvý stupeň) - celkový počet"
          // (samozrejme to iste plati pre diplomove a dizertacne prace)"
          // - to plati ale iba v pripade, ze v DB uz 3. input nie je vyplneny (t.j. je prazdny),
          // lebo ak uz bol vyplneny, tak ho nechceme prepisat
          if (control.value && control3.value === '') {
            zaverecnePraceSkupinaJazyk3FormArray?.controls[2]?.setValue(
              control.value,
              { emitEvent: false }
            );
          }

          this.subscriptions.push(
            control.valueChanges.subscribe(() => {
              this.prepocitajSucet(idTyp);
            })
          );

          const control2 = zaverecnePraceSkupinaJazyk3FormArray.controls[1];
          this.subscriptions.push(
            control2.valueChanges.subscribe(() => {
              this.prepocitajSucet(idTyp);
            })
          );

        }



      }

    }

  }

  private prepocitajSucet(idTyp: number): void {


    // zmeny v 1. jazyku asi pri zmene v 2. jazyku nechcem robit
    // if (this.kodJazykRadioBox === this.jazyk1) {

      const nameJazyk1 = 'name_' + idTyp + '_' + this.jazyk1;
      const zaverecnePraceSkupinaFormArray = this.formularFormGroup.get(nameJazyk1) as UntypedFormArray;


      const a = Number(zaverecnePraceSkupinaFormArray?.controls[0]?.value ?? 0);
      const b = Number(zaverecnePraceSkupinaFormArray?.controls[1]?.value ?? 0);

      zaverecnePraceSkupinaFormArray?.controls[2]?.setValue(
        a + b,
        { emitEvent: false }
      );

    // }


    if (this.existujeJazyk2) {
      const nameJazyk2 = 'name_' + idTyp + '_' + this.jazyk2;
      const zaverecnePraceSkupinaJazyk2FormArray = this.formularFormGroup.get(nameJazyk2) as UntypedFormArray;

      const a = Number(zaverecnePraceSkupinaJazyk2FormArray?.controls[0]?.value ?? 0);
      const b = Number(zaverecnePraceSkupinaJazyk2FormArray?.controls[1]?.value ?? 0);

      zaverecnePraceSkupinaJazyk2FormArray?.controls[2]?.setValue(
        a + b,
        { emitEvent: false }
      );

    }

    if (this.existujeJazyk3) {
      const nameJazyk3 = 'name_' + idTyp + '_' + this.jazyk3;
      const zaverecnePraceSkupinaJazyk3FormArray = this.formularFormGroup.get(nameJazyk3) as UntypedFormArray;

      const a = Number(zaverecnePraceSkupinaJazyk3FormArray?.controls[0]?.value ?? 0);
      const b = Number(zaverecnePraceSkupinaJazyk3FormArray?.controls[1]?.value ?? 0);

      zaverecnePraceSkupinaJazyk3FormArray?.controls[2]?.setValue(
        a + b,
        { emitEvent: false }
      );

    }

  }

  nastavSledovanieZmien() {

    // let zoznamSledovanychPoloziek = [];
    let idTypDatumuPoslednejModifikacie: number = null;
    for (const typ of this.typyZaznamuTextu) {
      if (typ.idPoslZmena && typ.idPoslZmena !== 0) {
        idTypDatumuPoslednejModifikacie = typ.idPoslZmena;

        // na zmeny treba pocuvat vo vsetkych jazykoch, lebo uzivatel si moze zvolit kombinaciu jazykov
        for (const kodJazyk of this.appStateService.jazykyFormulara) {

          let nameControl = '';
          if (typ.idSkupina && typ.idSkupina !== 0) {

            nameControl = 'name_' + typ.idSkupina + '_' + kodJazyk;

          } else {

            nameControl = 'name_' + typ.id + '_' + kodJazyk;

          }

          const control = this.formularFormGroup.get(nameControl);

          control?.valueChanges.pipe(
            debounceTime(400),
            takeUntilDestroyed(this.destroyRef)
          ).subscribe(() => {

            // this.zmenaVSledovanychPolozkach = true;
            this.zmenaVSledovanychPolozkachVJazykochMapa.set(kodJazyk, true);
            // this.aktualizujDatumModifikacie(typ.idPoslZmena);

            // console.log('Zmenena polozka: ' + nameControl + ' v jazyku: ' + kodJazyk);


          });

        }

      }

      // pocuvanie musime nastavit aj na datum poslednej aktualizacie pre pripad,
      // ze uzivatel zmeni datum poslednej aktualizacie manualne

      if (idTypDatumuPoslednejModifikacie ?? 0 === typ.id) {
        this.typDatumPoslednejAktualizacie = typ;
      }


    }

  }


  oznacAkoManualneUpravene() {
    this.datumPoslednejAktualizacieBolManualneZmeneny = true;
  }

  aktualizujDatumPoslednejAktualizacie(ulozitLenAktualnuStranu: boolean) {

    // ak uzivatel zmenil datum poslednej aktualizacie manualne,
    // tak ho nebudeme menit na aktualny datum
    if (this.datumPoslednejAktualizacieBolManualneZmeneny) {
      return;
    }

    const dnes = new Date().toISOString().split('T')[0];

    // premenna kodJazykovPole je pole, aby sme vedeli, ze ide o kombinaciu jazykov
    let kodyJazykovPole: string[] = [];
    //v pripade ukladania len aktualnej strany sa treba pozriet na to,
    // ake jazyky su zvolene v radioboxe (this.kodJazykRadioBox (uzivatel si moze zvolit kombinaciu jazykov)).
    // Ak ukladam cely formular, jazyky neriesim, lebo ukladam vsetky, pre ktore je formular dostupny (this.appStateService.jazykyFormulara)
    if (ulozitLenAktualnuStranu) {
      kodyJazykovPole = this.kodJazykRadioBox.split(', ');
    } else {
      kodyJazykovPole = this.appStateService.jazykyFormulara;
    }
    // const kodJazykPole = this.kodJazykRadioBox.split(', ');

    for (const kodJazyk of kodyJazykovPole) {

      // ak v danom jazyku zmena nenastala, tak datum poslednej aktualizacie nebudeme menit
      if (!this.zmenaVSledovanychPolozkachVJazykochMapa.get(kodJazyk)) {
        continue;
      }

      const nameOfControl = 'name_' + this.typDatumPoslednejAktualizacie?.id
        + '_' + kodJazyk;

      // Keďže toto pole nesledujeme, môžeme použiť obyčajné setValue/patchValue
      // a používateľ si ho môže kedykoľvek prepísať na čo chce
      this.formularFormGroup.get(nameOfControl)?.patchValue(dnes);

    }

  }



  pridajDatumPoslednejAktualizacieDoZoznamuNaOdoslanie(
    zaznamyTextovNaOdoslaniePole: ZaznamTextu[], kodJazyk?: string) {

    // premenna kodJazykovPole je pole, aby sme vedeli, ze ide o kombinaciu jazykov
    let kodyJazykovPole: string[] = [];
    if (kodJazyk) {
      kodyJazykovPole = [kodJazyk];
    } else {
      kodyJazykovPole = this.kodJazykRadioBox.split(', ');
    }

    if (this.typDatumPoslednejAktualizacie) {

      // cyklus preto, lebo vo formulari si mozem zvolit aj kombinaciu jazykov, tak nech sa
      // datum poslednej aktualizacie ulozi vo vsetkych, ktore su zvolene
      for (const kodJazyk of kodyJazykovPole) {

        // ak v danom jazyku zmena nenastala, tak datum poslednej aktualizacie nebudeme ukladat
        if (!this.zmenaVSledovanychPolozkachVJazykochMapa.get(kodJazyk)) {
          continue;
        }


        const menoControlsu = 'name_' + this.typDatumPoslednejAktualizacie?.id + '_' + kodJazyk;
        let valueControlsu = this.formularFormGroup.get(menoControlsu).value;

        if (!valueControlsu || valueControlsu === '') {
          return;
        }


        const datumPoslednejAktualizacieZaznam = new ZaznamTextu();

        datumPoslednejAktualizacieZaznam.idTypZaznamTextu = this.typDatumPoslednejAktualizacie.id;
        datumPoslednejAktualizacieZaznam.kodJazyk = kodJazyk;
        datumPoslednejAktualizacieZaznam.idOsoba = this.idOsoby;
        datumPoslednejAktualizacieZaznam.idStudProgram = this.idStudProgram;
        datumPoslednejAktualizacieZaznam.idPodprogram = this.idPodprogram;
        // pre istotu kontrola, ci ide naozaj o DATE
        if (this.typDatumPoslednejAktualizacie.idTypObjektu === this.DATE) {
          valueControlsu = valueControlsu?.toString()?.trim();
          const dateEN = this.datePipe.transform(valueControlsu, 'yyyy-MM-dd');
          datumPoslednejAktualizacieZaznam.text = dateEN;
          datumPoslednejAktualizacieZaznam.textString = dateEN;
        }

        zaznamyTextovNaOdoslaniePole.push(datumPoslednejAktualizacieZaznam);
      }

    }



  }

}
